import React, { useState, useEffect } from 'react';
import { Container, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Link, useNavigate } from 'react-router-dom';
import { encryptData } from '../../utils/cryptoUtils';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../common.scss';

import config from '../../config';

function EligibleRepoList() {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [page, setPage] = useState(1);
  const [loadingId, setLoadingId] = useState(null);
  const [uploadingId, setUploadingId] = useState(null);
  const [files, setFiles] = useState({});

  // --- PRELOADER: tracks POST request in-flight state (for modal submissions) ---
  const [postLoading, setPostLoading] = useState(false);
  const [showNotesModal, setShowNotesModal] = useState(false);
  const [selectedAgreement, setSelectedAgreement] = useState('');
  const [selectedAction, setSelectedAction] = useState('');
  const [notes, setNotes] = useState('');
  const [showResendModal, setShowResendModal] = useState(false);
  const [resendAgreement, setResendAgreement] = useState('');
  const [resendNotes, setResendNotes] = useState('');
  const [showReuploadModal, setShowReuploadModal] = useState(false);
  const [reuploadAgreement, setReuploadAgreement] = useState('');
  const [showViewNotesModal, setShowViewNotesModal] = useState(false);
  const [viewNotesContent, setViewNotesContent] = useState('');
  const [showActivityModal, setShowActivityModal] = useState(false);
  const [activityLogs, setActivityLogs] = useState([]);
  const [activityLoading, setActivityLoading] = useState(false);
  const [showRepoDetailsModal, setShowRepoDetailsModal] = useState(false);
  const [repoDetails, setRepoDetails] = useState(null);
  const [repoDetailsLoading, setRepoDetailsLoading] = useState(false);
  const [showInventoryModal, setShowInventoryModal] = useState(false);
  const [inventoryDetails, setInventoryDetails] = useState(null);
  const [inventoryLoading, setInventoryLoading] = useState(false);
  const [expandedRow, setExpandedRow] = useState(null);
  const [showFlowModal, setShowFlowModal] = useState(false);

  const [showRepairCostModal, setShowRepairCostModal] = useState(false);
  const [repairCostData, setRepairCostData] = useState(null);
  const [repairCostLoading, setRepairCostLoading] = useState(false);

  const [selectedFlowItem, setSelectedFlowItem] = useState(null);
  const [repoFlowData, setRepoFlowData] = useState(null);
  const [showRefurbishmentModal, setShowRefurbishmentModal] = useState(false);
  const [refurbishmentDetails, setRefurbishmentDetails] = useState(null);
  const [refurbishmentLoading, setRefurbishmentLoading] = useState(false);
  const [showRHApprovalModal, setShowRHApprovalModal] = useState(false);
  const [showListingModal, setShowListingModal] = useState(false);
  const [listingAgreementNo, setListingAgreementNo] = useState('');
  const [listingRepoId, setListingRepoId] = useState('');
  const [listingNote, setListingNote] = useState('');
  const [rhActionType, setRhActionType] = useState('');
  const [rhAgreementNo, setRhAgreementNo] = useState('');
  const [rhNotes, setRhNotes] = useState('');
  const [expandedNotes, setExpandedNotes] = useState({});
  const [expandedSurrenderNotes, setExpandedSurrenderNotes] = useState({});
  const [showDealLockModal, setShowDealLockModal] = useState(false);
  const [dealLockRepoId, setDealLockRepoId] = useState('');
  const [dealLocked, setDealLocked] = useState('');
  const [dealLockNotes, setDealLockNotes] = useState('');
  const [dealAgreementNo, setDealAgreementNo] = useState('');
  const [dealAmount, setDealAmount] = useState('');
  const [tokenReceived, setTokenReceived] = useState('');
  const [tokenAmount, setTokenAmount] = useState('');
  const [dealScreenshot, setDealScreenshot] = useState(null);
  const [repairCostLimit, setRepairCostLimit] = useState(0);
  const [showListingAmountModal, setShowListingAmountModal] = useState(false);
  const [listingAmountAgreementNo, setListingAmountAgreementNo] = useState('');
  const [listingAmountRepoId, setListingAmountRepoId] = useState('');
  const [listingAmount1, setListingAmount1] = useState('');
  const [listingAmount2, setListingAmount2] = useState('');
  const [listingAmount3, setListingAmount3] = useState('');
  const [listingAmountNote, setListingAmountNote] = useState('');
  const [repairCostMap, setRepairCostMap] = useState({});
  const [showListingAmountApprovalModal, setShowListingAmountApprovalModal] = useState(false);
  const [listingAmountApprovalAgreement, setListingAmountApprovalAgreement] = useState('');
  const [listingAmountApprovalAction, setListingAmountApprovalAction] = useState('');
  const [listingAmountApprovalNote, setListingAmountApprovalNote] = useState('');
  const [showListingAmountDetailModal, setShowListingAmountDetailModal] = useState(false);
  const [listingAmountDetailData, setListingAmountDetailData] = useState(null);
  const [listingAmountDetailLoading, setListingAmountDetailLoading] = useState(false);
  const [showFinalRepairModal, setShowFinalRepairModal] = useState(false);
  const [finalRepairRepoId, setFinalRepairRepoId] = useState('');
  const [finalRepairAgreementNo, setFinalRepairAgreementNo] = useState('');
  const [finalRepairImages, setFinalRepairImages] = useState([]);
  const [finalRepairBill, setFinalRepairBill] = useState(null);
  const [beneficiaryName, setBeneficiaryName] = useState('');
  const [bankName, setBankName] = useState('');
  const [accountNo, setAccountNo] = useState('');
  const [ifscCode, setIfscCode] = useState('');
  const [showFinalRepairViewModal, setShowFinalRepairViewModal] = useState(false);
  const [finalRepairViewData, setFinalRepairViewData] = useState(null);
  const [finalRepairViewLoading, setFinalRepairViewLoading] = useState(false);

  const [showCreditFinalRepairActionModal, setShowCreditFinalRepairActionModal] = useState(false);
  const [creditFinalRepairAgreement, setCreditFinalRepairAgreement] = useState('');
  const [creditFinalRepairAction, setCreditFinalRepairAction] = useState('');
  const [creditFinalRepairNote, setCreditFinalRepairNote] = useState('');

  const [showRHFinalRepairActionModal, setShowRHFinalRepairActionModal] = useState(false);
  const [rhFinalRepairAgreement, setRhFinalRepairAgreement] = useState('');
  const [rhFinalRepairAction, setRhFinalRepairAction] = useState('');
  const [rhFinalRepairNote, setRhFinalRepairNote] = useState('');

  // --- FINANCE TEAM FLOW STATES ---
  const [showFinanceTransferModal, setShowFinanceTransferModal] = useState(false);
  const [financeTransferAgreement, setFinanceTransferAgreement] = useState('');
  const [financeTransferRepoId, setFinanceTransferRepoId] = useState('');
  const [financeTransferNote, setFinanceTransferNote] = useState('');

  const [showFinanceAcceptModal, setShowFinanceAcceptModal] = useState(false);
  const [financeAcceptAgreement, setFinanceAcceptAgreement] = useState('');
  const [financeAcceptNote, setFinanceAcceptNote] = useState('');

  const [showFinanceUploadModal, setShowFinanceUploadModal] = useState(false);
  const [financeUploadAgreement, setFinanceUploadAgreement] = useState('');
  const [financeUploadRepoId, setFinanceUploadRepoId] = useState('');
  const [financeUploadFile, setFinanceUploadFile] = useState(null);
  const [financeUploadNote, setFinanceUploadNote] = useState('');

  const [showPaymentProofModal, setShowPaymentProofModal] = useState(false);
  const [paymentProofData, setPaymentProofData] = useState(null);
  const [paymentProofLoading, setPaymentProofLoading] = useState(false);
  // --- VISITOR TRACKING STATES ---
  const [showVisitorListModal, setShowVisitorListModal] = useState(false);
  const [visitorListRepoId, setVisitorListRepoId] = useState('');
  const [visitorListAgreementNo, setVisitorListAgreementNo] = useState('');
  const [visitors, setVisitors] = useState([]);
  const [visitorLoading, setVisitorLoading] = useState(false);

  const [showAddVisitorModal, setShowAddVisitorModal] = useState(false);
  const [visitorName, setVisitorName] = useState('');
  const [visitorNumber, setVisitorNumber] = useState('');
  const [visitorAadharPhoto, setVisitorAadharPhoto] = useState(null);
  const [visitorPanPhoto, setVisitorPanPhoto] = useState(null);
  const [visitingInspector, setVisitingInspector] = useState('');
  const [visitorType, setVisitorType] = useState('');

  const [showFollowupModal, setShowFollowupModal] = useState(false);
  const [selectedVisitor, setSelectedVisitor] = useState(null);
  const [followupList, setFollowupList] = useState([]);

  const [followupType, setFollowupType] = useState('');
  const [followupAction, setFollowupAction] = useState('');
  const [followupNote, setFollowupNote] = useState('');
  const [followupMaster, setFollowupMaster] = useState([]);

  const [listingAmountOptions, setListingAmountOptions] = useState(null);
  const [listingAmountOptionsLoading, setListingAmountOptionsLoading] = useState(false);
  const [selectedListingApprovedAmount, setSelectedListingApprovedAmount] = useState('');

  const [showSimpleListingAmountModal, setShowSimpleListingAmountModal] = useState(false);
  const [simpleListingAmount, setSimpleListingAmount] = useState(null);

  const [totalPages, setTotalPages] = useState(1);
  const navigate = useNavigate();
  const perPage = 10;

  const userInfo = useSelector((state) => state.userInfo);
  console.log('my data', userInfo);

  const userId = userInfo?.id;

  const [userRoleType, setUserRoleType] = useState('');

  useEffect(() => {
    const roleName = localStorage.getItem('authUserRoleName');
    if (roleName !== undefined && roleName !== null) {
      setUserRoleType(roleName);
    }
  }, []);

  const userRole = userRoleType?.toLowerCase().trim();
  const allowedRepoUsers = [
    'super admin',
    'manager',
    'team leader',
    'user',
    'dealer',
    'regional sales manager',
    'regional head',
    'cluster head',
  ];

  console.log('ROLE:', userRole);
  const isAdmin = userRole === 'super admin';

  const isMaker = [
    'user',
    'manager',
    'team leader',
    'regional sales manager',
    'regional head',
    'cluster head',
    'super admin',
  ].includes(userRole);

  const isRH = ['Head Retail'].includes(userRole);

  const isChecker = ['credit operations', 'super admin'].includes(userRole);

  const isFinanceTeam = ['finance team'].includes(userRole);

  const isSubAccountent = ['sub accounts'].includes(userRole);

  const allowedStatuses = [
    'Court Order Approved',
    'Repo Initiated',
    'Repo Checklist Submitted',
    'Inspection Scheduled',
    'Inventory Created',
    'Ready For Listing Approval',
    'Pending Listing Approval',
    'Listing Approval Granted',
    'Listing Approval Rejected',
    'Vehicle Surrender',
    'Deal Locked',
    'Pending Listing Amount Approval',
    'Listing Amount Approved',
    'Listing Amount Rejected',
    //   "Yard Placement Pending",
    //   "Vehicle Yarded",
    //   "Inventory Created"
  ];

  // const visibleData = data.filter(item => {
  //   const status = item.legal_status || item.status;

  //   return (
  //     status &&
  //     ![
  //       "Pending",
  //       "Approved",
  //       "Rejected",
  //       "Pending for Court Order Review",
  //       "Court Order Rejected"
  //     ].includes(status)
  //   );
  // });

  const fetchData = () => {
    fetch(`${config.API_BASE_URL}getEligibleLoansForRepo?page=${page}&limit=10&status=${statusFilter}&search=${search}`)
      .then((res) => res.json())
      .then((res) => {
        if (res.status) {
          setData(res.data || []);
          setTotalPages(res.pagination?.total_pages || 1);
        } else {
          toast.error('Failed to load data');
        }
      })
      .catch(() => toast.error('API Error'));
  };

  useEffect(() => {
    fetchData();
  }, [page, statusFilter, search]);

  const handleCommercialApprovalAction = async (agreementNo, action, repoId) => {
    try {
      const res = await fetch(`${config.API_BASE_URL}approveRejectCommercialApproval`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          agreement_no: agreementNo,
          action,
          user_id: userId,
        }),
      });

      const text = await res.text();

      console.log('Commercial Approval API Response:', text);

      let result;

      try {
        result = JSON.parse(text);
      } catch (e) {
        console.error('Invalid JSON Response:', text);
        toast.error('Server returned invalid response');
        return;
      }

      if (result.status) {
        toast.success(result.message);

        if (action === 'approve') {
          navigate(`/dashboard/final-submission/${btoa(String(repoId))}`);
        } else {
          navigate(`/dashboard/commercial-approval/${btoa(String(repoId))}`);
        }

        fetchData();
      } else {
        toast.error(result.message || 'Something went wrong');
      }
    } catch (error) {
      console.error('Commercial Approval Error:', error);
      toast.error('API Error');
    }
  };

  const handleCommercialRHAction = (repoId, action) => {
    if (action === 'approve') {
      navigate(`/dashboard/final-submission/${btoa(String(repoId))}`);
    } else {
      navigate(`/dashboard/commercial-approval/${btoa(String(repoId))}`);
    }
  };

  const handleSendForApproval = async (agreementNo) => {
    try {
      setLoadingId(agreementNo);

      const res = await fetch(`${config.API_BASE_URL}createLegalAction`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          agreement_no: agreementNo,
          legal_type: 'Section 9',
          user_id: userId,
        }),
      });

      const result = await res.json();

      if (result.status) {
        toast.success('Sent for approval');
        fetchData();
      } else {
        toast.error(result.message);
      }
    } catch {
      toast.error('Error sending request');
    } finally {
      setLoadingId(null);
    }
  };

  const handleAction = async (agreementNo, action) => {
    try {
      const res = await fetch(`${config.API_BASE_URL}approverejectLegalAction`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          agreement_no: agreementNo,
          action,
          checker_id: userId,
        }),
      });

      const result = await res.json();

      if (result.status) {
        toast.success(`Action ${action} successful`);
        fetchData();
      } else {
        toast.error(result.message);
      }
    } catch {
      toast.error('Error processing action');
    }
  };

  const handleDownloadCourtOrder = (courtOrderFile) => {
    if (!courtOrderFile) {
      toast.error('Court order file not available');
      return;
    }

    const fileUrl = `${config.API_BASE_URL}${courtOrderFile}`;
    window.open(fileUrl, '_blank');
  };

  const handleUploadCourtOrder = async (agreementNo) => {
    const selectedFile = files[agreementNo];

    if (!selectedFile) {
      toast.error('Please select file');
      return;
    }

    const formData = new FormData();
    formData.append('agreement_no', agreementNo);
    formData.append('file', selectedFile);
    formData.append('user_id', userId);

    // --- PRELOADER: show overlay before POST request ---
    setPostLoading(true);

    try {
      const res = await fetch(`${config.API_BASE_URL}uploadCourtOrder`, {
        method: 'POST',
        body: formData,
      });

      const result = await res.json();

      if (result.status) {
        toast.success('Court order uploaded');
        setUploadingId(null);

        setFiles((prev) => {
          const updated = { ...prev };
          delete updated[agreementNo];
          return updated;
        });

        fetchData();
      } else {
        toast.error(result.message);
      }
    } catch {
      toast.error('Upload failed');
    } finally {
      setPostLoading(false);
    }
  };

  const handleCourtOrderAction = (agreementNo, action) => {
    setSelectedAgreement(agreementNo);
    setSelectedAction(action);
    setNotes('');
    setShowNotesModal(true);
  };

  const handleRHApprovalAction = (agreementNo, action) => {
    setRhAgreementNo(agreementNo);
    setRhActionType(action);
    setRhNotes('');
    setShowRHApprovalModal(true);
  };

  const handleReuploadCourtOrder = (agreementNo) => {
    setReuploadAgreement(agreementNo);
    setResendNotes('');
    setShowReuploadModal(true);
  };

  const handleViewActivities = async (agreementNo) => {
    try {
      setActivityLoading(true);
      setShowActivityModal(true);

      const res = await fetch(`${config.API_BASE_URL}getCaseActivityLogs/${agreementNo}`);

      const result = await res.json();

      if (result.status) {
        setActivityLogs(result.data || []);
      } else {
        toast.error(result.message || 'No activities found');
        setActivityLogs([]);
      }
    } catch {
      toast.error('Failed to load activities');
    } finally {
      setActivityLoading(false);
    }
  };

  const handleViewRepoDetails = async (agreementNo) => {
    try {
      setRepoDetailsLoading(true);
      setShowRepoDetailsModal(true);

      const res = await fetch(`${config.API_BASE_URL}getCompleteRepoDetails/${agreementNo}`);

      const result = await res.json();

      if (result.status) {
        setRepoDetails(result.data);
      } else {
        toast.error(result.message || 'Details not found');
        setRepoDetails(null);
      }
    } catch {
      toast.error('Failed to load repo details');
    } finally {
      setRepoDetailsLoading(false);
    }
  };

  const handleViewInventory = async (agreementNo) => {
    try {
      setInventoryLoading(true);
      setShowInventoryModal(true);

      const res = await fetch(`${config.API_BASE_URL}getInventoryDetails/${agreementNo}`);

      const result = await res.json();

      if (result.status) {
        setInventoryDetails(result.data);
      } else {
        toast.error(result.message || 'Inventory not found');
        setInventoryDetails(null);
      }
    } catch {
      toast.error('Failed to load inventory');
    } finally {
      setInventoryLoading(false);
    }
  };

  useEffect(() => {
    fetch(`${config.API_BASE_URL}getRepairCostLimit`)
      .then((res) => res.json())
      .then((res) => {
        if (res.status) {
          setRepairCostLimit(Number(res.data?.amount || 0));
        }
      })
      .catch(() => {});
  }, []);

  const handleListingApprovalOpen = (agreementNo, repoId) => {
    setListingAgreementNo(agreementNo);

    setListingRepoId(repoId);

    setListingNote('');

    setShowListingModal(true);
  };

  const handleViewRefurbishment = (repoId) => {
    navigate(`/dashboard/refurbishment-detail/${btoa(String(repoId))}`);
  };

  const handleViewRepairCost = async (repoId) => {
    try {
      setRepairCostLoading(true);
      setRepairCostData(null);
      setShowRepairCostModal(true);

      const res = await fetch(`${config.API_BASE_URL}getRefurbishmentCostDetails/${repoId}`);
      const result = await res.json();

      if (result.status) {
        setRepairCostData(result.data);
      } else {
        toast.error(result.message || 'Data not found');
        setShowRepairCostModal(false);
      }
    } catch {
      toast.error('Failed to load repair cost');
      setShowRepairCostModal(false);
    } finally {
      setRepairCostLoading(false);
    }
  };

  const handleViewListingAmountDetails = async (agreementNo) => {
    try {
      setListingAmountDetailLoading(true);
      setListingAmountDetailData(null);
      setShowListingAmountDetailModal(true);

      const res = await fetch(`${config.API_BASE_URL}getListingAmountDetails/${agreementNo}`);
      const result = await res.json();

      if (result.status) {
        setListingAmountDetailData(result.data);
      } else {
        toast.error(result.message || 'Data not found');
        setShowListingAmountDetailModal(false);
      }
    } catch {
      toast.error('Failed to load listing amount details');
      setShowListingAmountDetailModal(false);
    } finally {
      setListingAmountDetailLoading(false);
    }
  };

  const handleStaticFlowModal = async (item) => {
    try {
      const res = await fetch(`${config.API_BASE_URL}get-repo-progress-flow?agreement_no=${item.AgreementNo}`);

      const result = await res.json();

      if (result.status) {
        setRepoFlowData(result);

        setSelectedFlowItem(item);

        setShowFlowModal(true);
      } else {
        toast.error(result.message);
      }
    } catch {
      toast.error('Failed to load progress');
    }
  };

  const handleViewFinalRepairSubmission = async (repoId) => {
    try {
      setFinalRepairViewLoading(true);
      setFinalRepairViewData(null);
      setShowFinalRepairViewModal(true);

      const res = await fetch(`${config.API_BASE_URL}getFinalRepairSubmission/${repoId}`);
      const result = await res.json();

      if (result.status) {
        setFinalRepairViewData(result.data);
      } else {
        toast.error(result.message || 'No data found');
        setShowFinalRepairViewModal(false);
      }
    } catch {
      toast.error('Failed to load final repair details');
      setShowFinalRepairViewModal(false);
    } finally {
      setFinalRepairViewLoading(false);
    }
  };

  const handleOpenCreditFinalRepairAction = (agreementNo, action) => {
    setCreditFinalRepairAgreement(agreementNo);
    setCreditFinalRepairAction(action);
    setCreditFinalRepairNote('');
    setShowCreditFinalRepairActionModal(true);
  };

  const submitCreditFinalRepairAction = async () => {
    if (!creditFinalRepairNote.trim()) {
      toast.error('Please enter notes');
      return;
    }

    try {
      setPostLoading(true);

      const payload = {
        agreement_no: creditFinalRepairAgreement,
        action: creditFinalRepairAction,
        notes: creditFinalRepairNote,
        user_id: userId,
      };

      const res = await fetch(`${config.API_BASE_URL}approveRejectCreditFinalRepair`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: encryptData(payload), // <-- encrypted body
      });

      const result = await res.json();

      if (result.status) {
        toast.success(result.message);
        setShowCreditFinalRepairActionModal(false);
        fetchData();
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong');
    } finally {
      setPostLoading(false);
    }
  };

  // --- VISITOR TRACKING HANDLERS ---
  const handleOpenVisitorList = async (agreementNo, repoId) => {
    setVisitorListAgreementNo(agreementNo);
    setVisitorListRepoId(repoId);
    setShowVisitorListModal(true);
    setVisitors([]);

    try {
      setVisitorLoading(true);
      const res = await fetch(`${config.API_BASE_URL}getVehicleVisitors/${agreementNo}`);
      const result = await res.json();

      if (result.status) {
        setVisitors(result.data || []);
      } else {
        setVisitors([]);
      }
    } catch (err) {
      console.error(err);
      toast.error('Failed to load visitors');
    } finally {
      setVisitorLoading(false);
    }
  };

  const openFollowupModal = async (visitor) => {
    try {
      setSelectedVisitor(visitor);
      setShowFollowupModal(true);

      const res = await fetch(`${config.API_BASE_URL}getVehicleVisitorFollowups/${visitor.id}`);

      const text = await res.text();

      console.log('Followup API:', text);

      if (!text) {
        setFollowupList([]);
        return;
      }

      const result = JSON.parse(text);

      if (result.status) {
        setFollowupList(result.data || []);
      } else {
        setFollowupList([]);
        toast.error(result.message);
      }
    } catch (err) {
      console.error(err);
      toast.error('Unable to load followups');
      setFollowupList([]);
    }
  };

  const saveVehicleVisitorFollowup = async () => {
    if (!followupType) {
      toast.error('Select Followup Type');
      return;
    }

    if (!followupAction) {
      toast.error('Select Action');
      return;
    }

    try {
      setPostLoading(true);

      const res = await fetch(`${config.API_BASE_URL}saveVehicleVisitorFollowup`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          visitor_id: selectedVisitor.id,
          followup_type: followupType,
          followup_action: followupAction,
          note: followupNote,
          user_id: userId,
        }),
      });

      const result = await res.json();

      if (result.status) {
        toast.success(result.message);

        setFollowupType('');
        setFollowupAction('');
        setFollowupNote('');

        // reload history
        openFollowupModal(selectedVisitor);
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      console.log(err);
      toast.error('Something went wrong');
    } finally {
      setPostLoading(false);
    }
  };

  const getFollowupMaster = async () => {
    try {
      const res = await fetch(`${config.API_BASE_URL}getVehicleFollowupMaster`);

      const result = await res.json();

      if (result.status) {
        setFollowupMaster(result.data || []);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getFollowupMaster();
  }, []);

  const handleOpenAddVisitor = () => {
    setVisitorName('');
    setVisitorNumber('');
    setVisitorAadharPhoto(null);
    setVisitorPanPhoto(null);
    setVisitingInspector('');
    setVisitorType('');
    setShowAddVisitorModal(true);
  };

  const submitAddVisitor = async () => {
    if (!visitorName.trim()) {
      toast.error('Please enter visitor name');
      return;
    }
    if (!visitorNumber.trim()) {
      toast.error('Please enter visitor number');
      return;
    }
    if (!visitorType) {
      toast.error('Please select visitor type');
      return;
    }

    const formData = new FormData();
    formData.append('repo_id', visitorListRepoId);
    formData.append('agreement_no', visitorListAgreementNo);
    formData.append('name', visitorName);
    formData.append('number', visitorNumber);
    formData.append('visiting_inspector', visitingInspector);
    formData.append('visitor_type', visitorType);
    formData.append('user_id', userId);

    if (visitorAadharPhoto) formData.append('aadhar_photo', visitorAadharPhoto);
    if (visitorPanPhoto) formData.append('pan_photo', visitorPanPhoto);

    try {
      setPostLoading(true);

      const res = await fetch(`${config.API_BASE_URL}saveVehicleVisitor`, {
        method: 'POST',
        body: formData,
      });

      const result = await res.json();

      if (result.status) {
        toast.success(result.message);
        setShowAddVisitorModal(false);
        // list refresh — same agreement ke visitors dobara fetch
        handleOpenVisitorList(visitorListAgreementNo, visitorListRepoId);
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong');
    } finally {
      setPostLoading(false);
    }
  };

  const handleViewPaymentProof = async (agreementNo) => {
    try {
      setPaymentProofLoading(true);
      setPaymentProofData(null);
      setShowPaymentProofModal(true);

      const res = await fetch(`${config.API_BASE_URL}getFinancePaymentProof/${agreementNo}`);
      const result = await res.json();

      if (result.status) {
        setPaymentProofData(result.data);
      } else {
        toast.error(result.message || 'No payment proof found');
        setShowPaymentProofModal(false);
      }
    } catch (err) {
      console.error(err);
      toast.error('Failed to load payment proof');
      setShowPaymentProofModal(false);
    } finally {
      setPaymentProofLoading(false);
    }
  };

  const handleOpenRHFinalRepairAction = (agreementNo, action) => {
    setRhFinalRepairAgreement(agreementNo);
    setRhFinalRepairAction(action);
    setRhFinalRepairNote('');
    setShowRHFinalRepairActionModal(true);
  };

  const submitRHFinalRepairAction = async () => {
    if (!rhFinalRepairNote.trim()) {
      toast.error('Please enter notes');
      return;
    }

    try {
      setPostLoading(true);

      const payload = {
        agreement_no: rhFinalRepairAgreement,
        action: rhFinalRepairAction,
        notes: rhFinalRepairNote,
        user_id: userId,
      };

      const res = await fetch(`${config.API_BASE_URL}approveRejectRHFinalRepair`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: encryptData(payload), // <-- encrypted body
      });

      const result = await res.json();

      if (result.status) {
        toast.success(result.message);
        setShowRHFinalRepairActionModal(false);
        fetchData();
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong');
    } finally {
      setPostLoading(false);
    }
  };

  const submitListingAmountApproval = async () => {
    if (!listingAmount1.trim() || !listingAmount2.trim() || !listingAmount3.trim()) {
      toast.error('Please enter all 3 listing amounts');
      return;
    }

    if (!listingAmountNote.trim()) {
      toast.error('Please enter notes');
      return;
    }

    try {
      setPostLoading(true);

      const payload = {
        agreement_no: listingAmountAgreementNo,
        repo_id: listingAmountRepoId,
        listing_amount_1: listingAmount1,
        listing_amount_2: listingAmount2,
        listing_amount_3: listingAmount3,
        notes: listingAmountNote,
        user_id: userId,
      };

      const res = await fetch(`${config.API_BASE_URL}sendListingAmountForApproval`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: encryptData(payload),
      });

      const result = await res.json();

      if (result.status) {
        toast.success(result.message);

        setShowListingAmountModal(false);
        setListingAmountAgreementNo('');
        setListingAmountRepoId('');
        setListingAmount1('');
        setListingAmount2('');
        setListingAmount3('');
        setListingAmountNote('');

        fetchData();
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong');
    } finally {
      setPostLoading(false);
    }
  };

  const submitFinanceUpload = async () => {
    if (!financeUploadFile) {
      toast.error('Please select a file to upload');
      return;
    }

    const formData = new FormData();
    formData.append('agreement_no', financeUploadAgreement);
    formData.append('repo_id', financeUploadRepoId);
    formData.append('notes', financeUploadNote);
    formData.append('user_id', userId);
    formData.append('proof_file', financeUploadFile);

    try {
      setPostLoading(true);

      const res = await fetch(`${config.API_BASE_URL}uploadFinanceFinalRepairProof`, {
        method: 'POST',
        body: formData,
      });

      const result = await res.json();

      if (result.status) {
        toast.success(result.message);
        setShowFinanceUploadModal(false);
        fetchData();
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong');
    } finally {
      setPostLoading(false);
    }
  };

  const handleOpenFinalRepairModal = (agreementNo, repoId) => {
    setFinalRepairAgreementNo(agreementNo);
    setFinalRepairRepoId(repoId);
    setFinalRepairImages([]);
    setFinalRepairBill(null);
    setBeneficiaryName('');
    setBankName('');
    setAccountNo('');
    setIfscCode('');
    setShowFinalRepairModal(true);
  };

  const submitFinalRepairSubmission = async () => {
    if (finalRepairImages.length === 0) {
      toast.error('Please upload repaired vehicle images');
      return;
    }
    if (!finalRepairBill) {
      toast.error('Please upload the bill');
      return;
    }
    if (!beneficiaryName.trim() || !bankName.trim() || !accountNo.trim() || !ifscCode.trim()) {
      toast.error('Please enter complete vendor bank details');
      return;
    }

    const formData = new FormData();
    formData.append('agreement_no', finalRepairAgreementNo);
    formData.append('repo_id', finalRepairRepoId);
    formData.append('beneficiary_name', beneficiaryName);
    formData.append('bank_name', bankName);
    formData.append('account_no', accountNo);
    formData.append('ifsc_code', ifscCode);
    formData.append('bill_image', finalRepairBill);
    formData.append('user_id', userId);

    finalRepairImages.forEach((file) => {
      formData.append('repair_images[]', file);
    });

    try {
      setPostLoading(true);

      const res = await fetch(`${config.API_BASE_URL}saveFinalRepairSubmission`, {
        method: 'POST',
        body: formData,
      });

      const result = await res.json();

      if (result.status) {
        toast.success(result.message);
        setShowFinalRepairModal(false);
        fetchData();
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong');
    } finally {
      setPostLoading(false);
    }
  };

  // ---- Admin -> Transfer to Finance Team ----
  const handleOpenFinanceTransfer = (agreementNo, repoId) => {
    setFinanceTransferAgreement(agreementNo);
    setFinanceTransferRepoId(repoId);
    setFinanceTransferNote('');
    setShowFinanceTransferModal(true);
  };

  const submitFinanceTransfer = async () => {
    if (!financeTransferNote.trim()) {
      toast.error('Please enter notes');
      return;
    }
    try {
      setPostLoading(true);
      const payload = {
        agreement_no: financeTransferAgreement,
        repo_id: financeTransferRepoId,
        notes: financeTransferNote,
        user_id: userId,
      };
      const res = await fetch(`${config.API_BASE_URL}transferFinalRepairToFinance`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: encryptData(payload),
      });
      const result = await res.json();
      if (result.status) {
        toast.success(result.message);
        setShowFinanceTransferModal(false);
        fetchData();
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong');
    } finally {
      setPostLoading(false);
    }
  };

  // ---- Finance Team -> Accept ----
  const handleOpenFinanceAccept = (agreementNo) => {
    setFinanceAcceptAgreement(agreementNo);
    setFinanceAcceptNote('');
    setShowFinanceAcceptModal(true);
  };

  const submitFinanceAccept = async () => {
    if (!financeAcceptNote.trim()) {
      toast.error('Please enter notes');
      return;
    }
    try {
      setPostLoading(true);
      const payload = {
        agreement_no: financeAcceptAgreement,
        notes: financeAcceptNote,
        user_id: userId,
      };
      const res = await fetch(`${config.API_BASE_URL}approveFinanceFinalRepair`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: encryptData(payload),
      });
      const result = await res.json();
      if (result.status) {
        toast.success(result.message);
        setShowFinanceAcceptModal(false);
        fetchData();
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong');
    } finally {
      setPostLoading(false);
    }
  };

  // ---- Finance Team -> Upload Proof (Santosh) ----
  const handleOpenFinanceUpload = (agreementNo, repoId) => {
    setFinanceUploadAgreement(agreementNo);
    setFinanceUploadRepoId(repoId);
    setFinanceUploadFile(null);
    setFinanceUploadNote('');
    setShowFinanceUploadModal(true);
  };

  // const submitFinanceUpload = async () => {
  //   if (!financeUploadFile) {
  //     toast.error('Please select a file to upload');
  //     return;
  //   }

  //   const formData = new FormData();
  //   formData.append('agreement_no', financeUploadAgreement);
  //   formData.append('repo_id', financeUploadRepoId);
  //   formData.append('proof_file', financeUploadFile);
  //   formData.append('notes', financeUploadNote);
  //   formData.append('user_id', userId);

  //   try {
  //     setPostLoading(true);
  //     const res = await fetch(`${config.API_BASE_URL}uploadFinanceFinalRepairProof`, {
  //       method: 'POST',
  //       body: formData,
  //     });
  //     const result = await res.json();
  //     if (result.status) {
  //       toast.success(result.message);
  //       setShowFinanceUploadModal(false);
  //       fetchData();
  //     } else {
  //       toast.error(result.message);
  //     }
  //   } catch (err) {
  //     console.error(err);
  //     toast.error('Something went wrong');
  //   } finally {
  //     setPostLoading(false);
  //   }
  // };

  const repoFlowSteps = [
    'Pending',
    'Approved',
    'Pending for Court Order Review',
    'Court Order Approved',
    'Repo Initiated',
    'Repo Checklist Submitted',
    'Inspection Scheduled',
    'Inventory Created',
    'Yard Placement Pending',
    'Vehicle Yarded',
    'Ready For Listing Approval',
    'Listing Approved',
    'Live For Auction',
    'Auction Completed',
    'Case Closed',
  ];

  const logStepMap = {
    'legal action created': 1,
    'legal action approved': 2,
    'court order uploaded': 3,
    'court order approved': 4,
    'repo process initiated': 5,
    'repo checklist submitted': 6,
    'inspection scheduled': 7,
    'final inventory created': 8,
    'yard placement updated': 9,
    'vehicle yarded': 10,
    'ready for listing approval': 11,
    'listing approved': 12,
    'live for auction': 13,
    'auction completed': 14,
    'case closed': 15,
  };

  let currentStep = 1;

  if (activityLogs?.length > 0) {
    const sortedLogs = [...activityLogs].sort((a, b) => new Date(b.created_on) - new Date(a.created_on));

    sortedLogs.some((log) => {
      const matchedKey = Object.keys(logStepMap).find((key) =>
        log.log_description?.toLowerCase().includes(key.toLowerCase())
      );

      if (matchedKey) {
        currentStep = logStepMap[matchedKey];

        return true;
      }

      return false;
    });
  }

  // const filtered = visibleData.filter(item => {

  //   const status =
  //     item.legal_status || item.status || "";

  //   const matchesSearch =
  //     (item.AgreementNo || '')
  //       .toLowerCase()
  //       .includes(search.toLowerCase()) ||

  //     (item.contact_name || '')
  //       .toLowerCase()
  //       .includes(search.toLowerCase());

  //   const matchesStatus =
  //     !statusFilter ||
  //     status === statusFilter;

  //   return matchesSearch && matchesStatus;

  // });
  const filtered = data;
  const handleExportExcel = () => {
    const headers = [
      'Sr No',
      'Agreement No',
      'Customer',
      'Phone',
      'DPD',
      'Status',
      'Notes',
      'Created By',
      'Updated By',
    ];

    const rows = filtered.map((item, index) => [
      index + 1,

      item.AgreementNo || '-',

      item.contact_name || '-',

      item.mobile || '-',

      item.DPDDays || '-',

      item.legal_status || item.status || 'Eligible',

      item.notes || '-',

      item.created_by_name || '-',

      item.updated_by_name || '-',
    ]);

    const csvContent = [
      headers.join(','),

      ...rows.map((row) => row.map((value) => `"${String(value).replace(/"/g, '""')}"`).join(',')),
    ].join('\n');

    const blob = new Blob([csvContent], {
      type: 'text/csv;charset=utf-8;',
    });

    const link = document.createElement('a');

    const url = URL.createObjectURL(blob);

    link.setAttribute('href', url);

    link.setAttribute('download', `Repo_List_${Date.now()}.csv`);

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  };

  const submitCourtOrderAction = async () => {
    if (!notes.trim()) {
      toast.error('Please enter notes');
      return;
    }

    try {
      setPostLoading(true);

      const res = await fetch(`${config.API_BASE_URL}approveRejectCourtOrder`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          agreement_no: selectedAgreement,
          action: selectedAction,
          checker_id: userId,
          notes,
        }),
      });

      const result = await res.json();

      if (result.status) {
        toast.success(result.message);

        setShowNotesModal(false);
        setNotes('');
        setSelectedAgreement('');
        setSelectedAction('');

        fetchData();
      } else {
        toast.error(result.message);
      }
    } catch {
      toast.error('Something went wrong');
    } finally {
      setPostLoading(false);
    }
  };

  const submitRHApprovalAction = async () => {
    if (!rhNotes.trim()) {
      toast.error('Please enter notes');
      return;
    }

    try {
      setPostLoading(true);

      const res = await fetch(`${config.API_BASE_URL}approveRejectRHRefurbishment`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          agreement_no: rhAgreementNo,
          action: rhActionType,
          notes: rhNotes,
          user_id: userId,
        }),
      });

      const result = await res.json();

      if (result.status) {
        toast.success(result.message);

        setShowRHApprovalModal(false);

        setRhAgreementNo('');
        setRhActionType('');
        setRhNotes('');

        fetchData();
      } else {
        toast.error(result.message);
      }
    } catch {
      toast.error('Something went wrong');
    } finally {
      setPostLoading(false);
    }
  };

  const submitListingApproval = async () => {
    if (!listingNote.trim()) {
      toast.error('Please enter notes');
      return;
    }

    try {
      setPostLoading(true);

      const payload = {
        agreement_no: listingAgreementNo,
        repo_id: listingRepoId,
        notes: listingNote,
        user_id: userId,
      };

      const res = await fetch(`${config.API_BASE_URL}sendForListingApproval`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: encryptData(payload), // <-- encrypted body
      });

      const result = await res.json();

      if (result.status) {
        toast.success(result.message);

        setShowListingModal(false);
        setListingAgreementNo('');
        setListingRepoId('');
        setListingNote('');

        fetchData();
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong');
    } finally {
      setPostLoading(false);
    }
  };

  const submitDealLock = async () => {
    try {
      setPostLoading(true);

      const payload = {
        agreement_no: dealAgreementNo,
        repo_id: dealLockRepoId,
        deal_amount: dealAmount,
        token_received: tokenReceived,
        token_amount: tokenAmount,
        notes: dealLockNotes,
        user_id: userId,
      };

      console.log(payload);

      const res = await fetch(
        `${config.API_BASE_URL}saveDealLock`,

        {
          method: 'POST',

          headers: {
            'Content-Type': 'application/json',
          },

          body: encryptData(payload),
        }
      );

      const result = await res.json();

      if (result.status) {
        toast.success(result.message);

        setShowDealLockModal(false);

        fetchData();
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      console.log(err);

      toast.error('Something went wrong');
    } finally {
      setPostLoading(false);
    }
  };

  useEffect(() => {
    const pendingItems = data.filter(
      (item) =>
        (item.legal_status || item.status) === 'Pending RH Approval' &&
        item.repo_id &&
        repairCostMap[item.repo_id] === undefined
    );

    pendingItems.forEach((item) => {
      fetch(`${config.API_BASE_URL}getRefurbishmentCostDetails/${item.repo_id}`)
        .then((res) => res.json())
        .then((res) => {
          if (res.status) {
            setRepairCostMap((prev) => ({
              ...prev,
              [item.repo_id]: Number(res.data?.total_cost || 0),
            }));
          }
        })
        .catch(() => {});
    });
  }, [data]);

  const handleListingApprovalAction = async (agreementNo, action) => {
    try {
      setPostLoading(true);
      const payload = { agreement_no: agreementNo, action, user_id: userId };

      const res = await fetch(`${config.API_BASE_URL}approveRejectListingApproval`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: encryptData(payload),
      });
      const result = await res.json();
      if (result.status) {
        toast.success(result.message);
        fetchData();
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      console.log(err);
      toast.error('Something went wrong');
    } finally {
      setPostLoading(false);
    }
  };

  const handleListingAmountApprovalOpen = async (agreementNo, action) => {
    setListingAmountApprovalAgreement(agreementNo);
    setListingAmountApprovalAction(action);
    setListingAmountApprovalNote('');
    setSelectedListingApprovedAmount('');
    setListingAmountOptions(null);
    setShowListingAmountApprovalModal(true);

    if (action === 'approve') {
      try {
        setListingAmountOptionsLoading(true);
        const res = await fetch(`${config.API_BASE_URL}getListingAmountDetails/${agreementNo}`);
        const result = await res.json();
        if (result.status) {
          setListingAmountOptions(result.data);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setListingAmountOptionsLoading(false);
      }
    }
  };

  const submitListingAmountApprovalAction = async () => {
    if (!listingAmountApprovalNote.trim()) {
      toast.error('Please enter notes');
      return;
    }

    if (listingAmountApprovalAction === 'approve' && !selectedListingApprovedAmount) {
      toast.error('Please select a listing amount');
      return;
    }

    try {
      setPostLoading(true);

      const payload = {
        agreement_no: listingAmountApprovalAgreement,
        action: listingAmountApprovalAction,
        notes: listingAmountApprovalNote,
        user_id: userId,
        listing_approved_amount: selectedListingApprovedAmount, // <-- NEW FIELD
      };

      const res = await fetch(`${config.API_BASE_URL}approveRejectListingAmountApproval`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: encryptData(payload),
      });

      const result = await res.json();

      if (result.status) {
        toast.success(result.message);
        setShowListingAmountApprovalModal(false);
        setListingAmountApprovalAgreement('');
        setListingAmountApprovalAction('');
        setListingAmountApprovalNote('');
        setSelectedListingApprovedAmount('');
        setListingAmountOptions(null);
        fetchData();
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong');
    } finally {
      setPostLoading(false);
    }
  };

  const submitReuploadCourtOrder = async () => {
    const selectedFile = files[reuploadAgreement];

    if (!selectedFile) {
      toast.error('Please select file');
      return;
    }

    if (!resendNotes.trim()) {
      toast.error('Please enter notes');
      return;
    }

    const formData = new FormData();

    formData.append('agreement_no', reuploadAgreement);
    formData.append('file', selectedFile);
    formData.append('user_id', userId);
    formData.append('notes', resendNotes);

    try {
      // --- PRELOADER: show overlay before POST request ---
      setPostLoading(true);

      const res = await fetch(`${config.API_BASE_URL}uploadCourtOrder`, {
        method: 'POST',
        body: formData,
      });

      const result = await res.json();

      if (result.status) {
        toast.success(result.message);

        setShowReuploadModal(false);
        setReuploadAgreement('');
        setResendNotes('');

        fetchData();
      } else {
        toast.error(result.message);
      }
    } catch {
      toast.error('Upload failed');
    } finally {
      // --- PRELOADER: hide overlay after POST finishes ---
      setPostLoading(false);
    }
  };

  // 📄 PAGINATION
  // const start = (page - 1) * perPage;
  // const paginated = filtered.slice(start, start + perPage);
  // const totalPages = Math.ceil(filtered.length / perPage);

  const RepairBadge = () => {
    const [showProgress, setShowProgress] = React.useState(true);

    React.useEffect(() => {
      const interval = setInterval(() => {
        setShowProgress((prev) => !prev);
      }, 2000);
      return () => clearInterval(interval);
    }, []);

    return (
      <>
        <style>{`
        @keyframes fadeInBadge {
          0%   { opacity: 0; transform: translateY(-4px) scale(0.95); }
          100% { opacity: 1; transform: translateY(0px) scale(1); }
        }
      `}</style>

        {showProgress ? (
          <span
            key="progress"
            style={{
              display: 'inline-block',
              padding: '4px 12px',
              borderRadius: '20px',
              fontSize: '12px',
              fontWeight: '600',
              backgroundColor: '#7c3aed',
              color: '#ede9fe',
              animation: 'fadeInBadge 0.4s ease forwards',
              letterSpacing: '0.4px',
            }}
          >
            Repair In Progress
          </span>
        ) : (
          <span
            key="done"
            style={{
              display: 'inline-block',
              padding: '4px 12px',
              borderRadius: '20px',
              fontSize: '12px',
              fontWeight: '600',
              backgroundColor: '#0f766e',
              color: '#ccfbf1',
              animation: 'fadeInBadge 0.4s ease forwards',
              letterSpacing: '0.4px',
            }}
          >
            Repair Approved
          </span>
        )}
      </>
    );
  };

  return (
    <Container>
      {/* --- PRELOADER OVERLAY: shown during POST request --- */}
      {postLoading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(255,255,255,0.85)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backdropFilter: 'blur(3px)',
          }}
        >
          <div
            style={{
              width: '56px',
              height: '56px',
              border: '5px solid #e0e0e0',
              borderTop: '5px solid #1976d2',
              borderRadius: '50%',
              animation: 'spin 0.8s linear infinite',
            }}
          />
          <p style={{ marginTop: '18px', fontWeight: 600, color: '#1976d2', fontSize: '15px' }}>
            Processing, please wait...
          </p>
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              style={{
                width: '320px',
                height: '14px',
                borderRadius: '6px',
                marginTop: '10px',
                background: 'linear-gradient(90deg,#e0e0e0 25%,#f5f5f5 50%,#e0e0e0 75%)',
                backgroundSize: '400% 100%',
                animation: 'shimmer 1.4s infinite',
              }}
            />
          ))}
          <style>{`
              @keyframes spin { to { transform: rotate(360deg); } }
              @keyframes shimmer { 0%{background-position:100% 0} 100%{background-position:-100% 0} }
            `}</style>
        </div>
      )}
      {/* --- END PRELOADER OVERLAY --- */}

      <div className="d-flex justify-content-between align-items-center mb-3">
        <Typography variant="h4">Eligible Loans for Repo</Typography>
      </div>

      <div className="d-flex justify-content-end mb-2">
        <button
          className="btn btn-success"
          onClick={handleExportExcel}
          style={{
            fontSize: '12px',
            padding: '6px 14px',
          }}
        >
          ⬇ Export Excel
        </button>
      </div>
      {/* SEARCH */}
      <div className="row mb-3">
        <div className="col-md-3">
          <select
            className="form-select"
            value={statusFilter}
            onChange={(e) => {
              setStatusFilter(e.target.value);
              setPage(1);
            }}
          >
            <option value="">All Status</option>

            {allowedStatuses.map((status) => (
              <option key={status} value={status}>
                {status}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-4 ms-auto">
          <input
            type="text"
            className="form-control"
            placeholder="Search Agreement / Customer..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setPage(1);
            }}
          />
        </div>
      </div>

      {/* TABLE */}
      <div className="table-wrap">
        <table className="table table-hover align-middle">
          <thead className="table-light">
            <tr>
              <th style={{ width: '40px' }} />
              <th>#</th>
              <th>Agreement No</th>
              <th>Customer</th>
              <th>Phone</th>
              <th>Vehicle No</th>
              <th>DPD</th>
              <th>Status</th>
              <th width="220">Action</th>
              <th width="120">All Activities</th>
            </tr>
          </thead>

          <tbody>
            {filtered.map((item, index) => {
              const status = item.legal_status || item.status || 'Eligible';
              const isExpanded = expandedRow === item.AgreementNo;
              return (
                <tr
                  key={item.AgreementNo}
                  style={{ cursor: 'pointer' }}
                  onClick={() => setExpandedRow(isExpanded ? null : item.AgreementNo)}
                >
                  <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                    <span
                      style={{
                        display: 'inline-block',
                        transition: 'transform 0.25s',
                        transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
                        fontSize: '16px',
                        color: '#555',
                      }}
                    >
                      &#8250;
                    </span>
                  </td>
                  {/* <td>{start + index + 1}</td> */}
                  <td>{(page - 1) * 10 + index + 1}</td>
                  <td>
                    <Link
                      to={`/dashboard/allcloud-loans-report/${btoa(String(item.id))}/${btoa(String(item.AgreementNo))}`}
                      style={{ color: '#0d6efd', textDecoration: 'underline' }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      {item.AgreementNo}
                    </Link>
                  </td>
                  <td>{item.contact_name || '-'}</td>
                  <td>{item.mobile || '-'}</td>
                  <td>{item.vehicle_number || 'N/A'}</td>
                  <td>{item.DPDDays}</td>

                  {/* STATUS */}
                  <td>
                    {!status && <span className="badge bg-warning text-dark">Eligible</span>}

                    {status === 'Pending' && <span className="badge bg-secondary">Waiting</span>}

                    {status === 'Approved' && <span className="badge bg-success">Approved</span>}

                    {status === 'Rejected' && <span className="badge bg-danger">Rejected</span>}

                    {status === 'Pending for Court Order Review' && (
                      <span className="badge bg-warning text-dark">Court Order Uploaded</span>
                    )}

                    {status === 'Court Order Approved' && (
                      <span className="badge bg-success">LNR & Section 9 Uploaded</span>
                    )}

                    {status === 'Court Order Rejected' && <span className="badge bg-danger">Court Order Rejected</span>}

                    {status === 'Repo Initiated' && <span className="badge bg-info text-dark">Repo Initiated</span>}

                    {status === 'Repo Checklist Submitted' && (
                      <span className="badge bg-primary">Repo Checklist Submitted</span>
                    )}
                    {status === 'Inspection Scheduled' && <span className="badge bg-info">Inspection Scheduled</span>}
                    {status === 'Inventory Created' && <span className="badge bg-dark">Inventory Created</span>}

                    {status === 'Repair Approved' && <RepairBadge />}

                    {status === 'Ready For Listing Approval' && (
                      <span className="badge bg-warning text-dark">Ready For Listing Approval</span>
                    )}

                    {status === 'Pending Listing Approval' && (
                      <span className="badge bg-warning text-dark">Pending Listing Approval</span>
                    )}

                    {status === 'Listing Approval Granted' && (
                      <span
                        className="badge"
                        style={{
                          backgroundColor: '#1E9E57',
                          color: '#fff',
                          padding: '5px 8px',
                          borderRadius: '6px',
                          fontSize: '11px',
                          fontWeight: '500',
                        }}
                      >
                        Listing Approval Granted
                      </span>
                    )}

                    {status === 'Deal Locked' && (
                      <span
                        className="badge"
                        style={{
                          backgroundColor: '#198754',
                          color: '#fff',
                          padding: '5px 10px',
                          borderRadius: '6px',
                          fontSize: '11px',
                          fontWeight: '600',
                        }}
                      >
                        🔒 Deal Locked
                      </span>
                    )}

                    {status === 'Pending Listing Amount Approval' && (
                      <span className="badge bg-warning text-dark">Pending Listing Amount Approval</span>
                    )}

                    {status === 'Listing Amount Approved' && (
                      <span
                        className="badge"
                        style={{
                          backgroundColor: '#1E9E57',
                          color: '#fff',
                          padding: '5px 8px',
                          borderRadius: '6px',
                          fontSize: '11px',
                          fontWeight: '500',
                        }}
                      >
                        Listing Amount Approved
                      </span>
                    )}

                    {status === 'Listing Amount Rejected' && (
                      <span
                        className="badge"
                        style={{
                          backgroundColor: '#E53935',
                          color: '#fff',
                          padding: '5px 8px',
                          borderRadius: '6px',
                          fontSize: '11px',
                          fontWeight: '500',
                        }}
                      >
                        Listing Amount Rejected
                      </span>
                    )}

                    {status === 'Listing Approval Rejected' && (
                      <span
                        className="badge"
                        style={{
                          backgroundColor: '#E53935',
                          color: '#fff',
                          padding: '5px 8px',
                          borderRadius: '6px',
                          fontSize: '11px',
                          fontWeight: '500',
                        }}
                      >
                        Listing Approval Rejected
                      </span>
                    )}

                    {status === 'Pending Finance Team Approval' && (
                      <span className="badge bg-info text-dark">Pending Finance Team Approval</span>
                    )}

                    {status === 'Pending Finance Team Upload' && (
                      <span className="badge bg-warning text-dark">Pending Finance Upload</span>
                    )}

                    {status === 'Finance Repair Completed' && (
                      <span
                        className="badge"
                        style={{
                          backgroundColor: '#1E9E57',
                          color: '#fff',
                          padding: '5px 8px',
                          borderRadius: '6px',
                          fontSize: '11px',
                          fontWeight: '500',
                        }}
                      >
                        Finance Repair Completed
                      </span>
                    )}

                    {status === 'Pending RH Approval' && (
                      <span className="badge bg-warning text-dark">Pending BH Approval</span>
                    )}

                    {status === 'Pending RH Approval For Commercial Action' && (
                      <span className="badge bg-warning text-dark">Pending BH Approval For Final submission</span>
                    )}
                    {/* 
                      {status === "Commercial Approval Accepted" && isMaker && (
                          <>
                            {isExpanded && (
                              <div
                                style={{
                                  fontSize: "12px",
                                  color: "#198754",
                                  fontWeight: "600"
                                }}
                              >
                                Commercial Approval Accepted by {item.updated_by_name || "RH"}
                              </div>
                            )}

                            <button className="btn btn-success btn-sm">
                              Final Inventory
                            </button>
                          </>
                        )} */}

                    {status === 'Commercial Approval Accepted' && (
                      <span className="badge bg-success">Commercial Approved</span>
                    )}

                    {status === 'Commercial Approval Rejected' && (
                      <span className="badge bg-danger">Commercial Rejected</span>
                    )}

                    {status === 'Vehicle Surrender' && <span className="badge bg-danger">Vehicle Surrender</span>}

                    {status === 'Pending Credit Team Approval' && (
                      <span className="badge bg-warning text-dark">Pending Credit Team Approval</span>
                    )}

                    {status === 'Pending RH Final Approval' && (
                      <span className="badge bg-info text-dark">Pending BH Final Approval</span>
                    )}

                    {status === 'Final Repair Approved' && (
                      <span
                        className="badge"
                        style={{
                          backgroundColor: '#1E9E57',
                          color: '#fff',
                          padding: '5px 8px',
                          borderRadius: '6px',
                          fontSize: '11px',
                          fontWeight: '500',
                        }}
                      >
                        Final Repair Approved
                      </span>
                    )}
                    {status === 'Payment Done' && (
                      <span
                        className="badge"
                        style={{
                          backgroundColor: '#1E9E57',
                          color: '#fff',
                          padding: '5px 8px',
                          borderRadius: '6px',
                          fontSize: '11px',
                          fontWeight: '500',
                        }}
                      >
                        💰 Payment Done
                      </span>
                    )}
                  </td>

                  <td onClick={(e) => e.stopPropagation()}>
                    {status === 'Commercial Approval Accepted' && isMaker && (
                      <>
                        {isExpanded && (
                          <small className="text-success d-block mb-1">
                            Commercial Approval Accepted by {item.updated_by_name || 'BH'}
                          </small>
                        )}

                        <button
                          className="btn btn-sm btn-success"
                          style={{
                            height: '23px',
                            borderRadius: '5px',
                            padding: '5px 7px',
                            fontSize: '8.2px',
                            minWidth: '90px',
                            fontWeight: 'normal',
                          }}
                          onClick={() => navigate(`/dashboard/final-submission/${btoa(String(item.repo_id))}`)}
                        >
                          Final Inventory
                        </button>
                      </>
                    )}

                    {status === 'Commercial Approval Rejected' && isMaker && (
                      <>
                        {isExpanded && (
                          <small className="text-danger d-block mb-1">
                            Commercial Approval Rejected by {item.updated_by_name || 'BH'}
                          </small>
                        )}

                        <button
                          className="btn btn-sm btn-warning"
                          style={{
                            padding: '4px 10px',
                            fontSize: '9px',
                            textTransform: 'capitalize',
                          }}
                          onClick={() => navigate(`/dashboard/commercial-approval/${btoa(String(item.repo_id))}`)}
                        >
                          Re-Submit Commercial Approval
                        </button>
                      </>
                    )}
                    {/* REJECTED */}
                    {status === 'Rejected' && (
                      <div>
                        {isExpanded && (
                          <span className="text-danger d-block">Rejected by {item.updated_by_name || 'User'}</span>
                        )}

                        {(isMaker || isAdmin) && (
                          <button
                            className="btn btn-sm btn-warning mt-1"
                            style={{
                              padding: '4px 10px',
                              fontSize: '9px',
                              textTransform: 'capitalize',
                            }}
                            onClick={() => handleSendForApproval(item.AgreementNo)}
                          >
                            Send for Approval
                          </button>
                        )}
                      </div>
                    )}

                    {/* NEW CASE (no record yet) */}
                    {(isMaker || isAdmin) && !item.legal_status && (
                      <button
                        className="btn btn-sm btn-warning"
                        style={{
                          padding: '4px 10px',
                          fontSize: '9px',
                          textTransform: 'capitalize',
                        }}
                        onClick={() => handleSendForApproval(item.AgreementNo)}
                      >
                        Send for Approval
                      </button>
                    )}

                    {status === 'Pending' && (
                      <>
                        {isChecker ? (
                          <>
                            {isExpanded && (
                              <small className="text-primary d-block mb-1">
                                Sent for Approval by{' '}
                                {item.updated_by_name && item.notes
                                  ? item.updated_by_name
                                  : item.created_by_name || 'User'}
                              </small>
                            )}

                            <button
                              className="btn btn-sm btn-success me-2"
                              style={{
                                height: '23px',
                                borderRadius: '5px',
                                padding: '5px 7px',
                                fontSize: '8.2px',
                                minWidth: '90px',
                                fontWeight: 'normal',
                              }}
                              onClick={() => handleAction(item.AgreementNo, 'approve')}
                            >
                              ✓ Accept
                            </button>

                            <button
                              className="btn btn-sm btn-danger"
                              style={{
                                height: '23px',
                                borderRadius: '5px',
                                padding: '5px 7px',
                                fontSize: '8.2px',
                                minWidth: '90px',
                                fontWeight: 'normal',
                              }}
                              onClick={() => handleAction(item.AgreementNo, 'reject')}
                            >
                              ✕ Reject
                            </button>
                          </>
                        ) : (
                          isExpanded && (
                            <span className="text-primary">Sent for Approval by {item.created_by_name || 'User'}</span>
                          )
                        )}
                      </>
                    )}

                    {status === 'Pending Listing Approval' && isChecker && (
                      <>
                        {isExpanded && (
                          <>
                            <small className="text-success d-block mb-1">
                              Listing Approval Sent By {item.updated_by_name || item.created_by_name || 'User'}
                            </small>

                            <small className="text-muted d-block mb-2">
                              <strong>Notes:</strong>{' '}
                              {item.notes ? (expandedNotes[item.id] ? item.notes : item.notes.substring(0, 50)) : '-'}
                              {item.notes && item.notes.length > 50 && (
                                <button
                                  type="button"
                                  style={{
                                    color: '#007bff',
                                    cursor: 'pointer',
                                    marginLeft: '5px',
                                    fontWeight: '600',
                                    border: 'none',
                                    background: 'transparent',
                                    padding: 0,
                                  }}
                                  onClick={() =>
                                    setExpandedNotes((prev) => ({
                                      ...prev,
                                      [item.id]: !prev[item.id],
                                    }))
                                  }
                                >
                                  {expandedNotes[item.id] ? 'See Less' : 'See More'}
                                </button>
                              )}
                            </small>
                          </>
                        )}

                        <button
                          className="btn btn-sm btn-success me-2"
                          style={{
                            height: '23px',
                            borderRadius: '5px',
                            padding: '5px 7px',
                            fontSize: '8.2px',
                            minWidth: '90px',
                            fontWeight: 'normal',
                          }}
                          onClick={() => handleListingApprovalAction(item.AgreementNo, 'approve')}
                        >
                          ✓ Accept
                        </button>

                        <button
                          className="btn btn-sm btn-danger"
                          style={{
                            height: '23px',
                            borderRadius: '5px',
                            padding: '5px 7px',
                            fontSize: '8.2px',
                            minWidth: '90px',
                            fontWeight: 'normal',
                          }}
                          onClick={() => handleListingApprovalAction(item.AgreementNo, 'reject')}
                        >
                          ✕ Reject
                        </button>
                      </>
                    )}

                    {/* {status === "Pending RH Approval" && item.repo_id && (
                          <div className="mb-1">
                              <button
                                  type="button"
                                  onClick={() => handleViewRepairCost(item.repo_id)}
                                  style={{
                                      border: "none",
                                      background: "transparent",
                                      padding: "0",
                                      color: "#6f42c1",
                                      cursor: "pointer",
                                      fontSize: "12px",
                                      fontWeight: "600",
                                      textDecoration: "underline"
                                  }}
                              >
                                  🔧 View Repair Cost
                              </button>
                          </div>
                      )} */}

                    {/* LISTING APPROVAL GRANTED - MAKER */}

                    {status === 'Listing Approval Granted' && isMaker && (
                      <div className="mt-1">
                        {isExpanded && (
                          <>
                            <span className="text-success d-block">
                              Listing Approved By {item.updated_by_name || 'Checker'}
                            </span>

                            <small className="text-muted d-block">Vehicle is ready for Deal Lock.</small>

                            {item.notes && <small className="text-muted d-block mt-1">Notes : {item.notes}</small>}

                            <div className="d-flex gap-2 flex-wrap mt-2">
                              <button
                                className="btn btn-sm btn-dark"
                                onClick={() => navigate(`/dashboard/view-repo-checklist/${btoa(String(item.repo_id))}`)}
                                style={{
                                  padding: '4px 10px',
                                  fontSize: '9px',
                                  textTransform: 'capitalize',
                                }}
                              >
                                View Checklist
                              </button>
                            </div>
                          </>
                        )}

                        {/* <button
                          className="btn btn-sm btn-success mt-2"
                          style={{
                            padding: '4px 10px',
                            fontSize: '9px',
                            textTransform: 'capitalize',
                          }}
                          onClick={() => {
                            setDealLockRepoId(item.repo_id);

                            setDealAgreementNo(item.AgreementNo);

                            setShowDealLockModal(true);
                          }}
                        >
                          🔒 Is Deal Locked
                        </button> */}

                        <button
                          className="btn btn-sm btn-success mt-2"
                          style={{
                            padding: '4px 10px',
                            fontSize: '9px',
                            textTransform: 'capitalize',
                          }}
                          onClick={() => {
                            setListingAmountAgreementNo(item.AgreementNo);
                            setListingAmountRepoId(item.repo_id);
                            setListingAmount1('');
                            setListingAmount2('');
                            setListingAmount3('');
                            setListingAmountNote('');
                            setShowListingAmountModal(true);
                          }}
                        >
                          💰 Send Listing Amount For Approval
                        </button>
                      </div>
                    )}

                    {status === 'Listing Amount Approved' && isMaker && (
                      <div className="mt-1">
                        <button
                          className="btn btn-sm btn-outline-success mb-1"
                          style={{ padding: '4px 10px', fontSize: '9px', textTransform: 'capitalize' }}
                          onClick={() => {
                            setSimpleListingAmount(item.listing_approved_amount);
                            setShowSimpleListingAmountModal(true);
                          }}
                        >
                          💰 View Listing Amount
                        </button>
                        <br />
                        <button
                          className="btn btn-sm btn-success"
                          style={{ padding: '4px 10px', fontSize: '9px', textTransform: 'capitalize' }}
                          onClick={() => {
                            setDealLockRepoId(item.repo_id);
                            setDealAgreementNo(item.AgreementNo);
                            setDealAmount('');
                            setTokenReceived('');
                            setTokenAmount('');
                            setDealLockNotes('');
                            setShowDealLockModal(true);
                          }}
                        >
                          🔒 Is Deal Locked
                        </button>
                        <button
                          className="btn btn-sm btn-info text-white"
                          style={{
                            padding: '4px 16px',
                            fontSize: '9px',
                            marginLeft: '5px',
                            textTransform: 'capitalize',
                          }}
                          onClick={() => handleOpenVisitorList(item.AgreementNo, item.repo_id)}
                        >
                          👥 Visitors
                        </button>
                      </div>
                    )}

                    {/* LISTING APPROVAL GRANTED - CHECKER */}

                    {status === 'Listing Approval Granted' && isChecker && (
                      <div className="mt-1">
                        {isExpanded && (
                          <>
                            <span className="text-success d-block">
                              Listing Approved By {item.updated_by_name || 'Checker'}
                            </span>

                            <small className="text-muted d-block">Waiting for Deal Lock.</small>

                            {item.notes && <small className="text-muted d-block mt-1">Notes : {item.notes}</small>}

                            <button
                              className="btn btn-sm btn-dark mt-2"
                              onClick={() => navigate(`/dashboard/view-repo-checklist/${btoa(String(item.repo_id))}`)}
                              style={{
                                padding: '4px 10px',
                                fontSize: '9px',
                                textTransform: 'capitalize',
                              }}
                            >
                              View Checklist
                            </button>
                          </>
                        )}
                      </div>
                    )}

                    {/* LISTING APPROVAL REJECTED - MAKER */}

                    {status === 'Listing Approval Rejected' && isMaker && (
                      <div className="mt-1">
                        {isExpanded && (
                          <>
                            <span className="text-danger d-block">
                              Listing Approval Rejected By {item.updated_by_name || 'Checker'}
                            </span>

                            <small className="text-muted d-block">Listing approval needs resubmission.</small>

                            {item.notes && <small className="text-muted d-block mt-1">Notes : {item.notes}</small>}

                            <button
                              className="btn btn-sm btn-dark mt-2 me-2"
                              onClick={() => navigate(`/dashboard/view-repo-checklist/${btoa(String(item.repo_id))}`)}
                              style={{
                                padding: '4px 10px',
                                fontSize: '9px',
                                textTransform: 'capitalize',
                              }}
                            >
                              View Checklist
                            </button>
                          </>
                        )}

                        <button
                          className="btn btn-sm btn-warning mt-2"
                          onClick={() => handleListingApprovalOpen(item.AgreementNo, item.repo_id)}
                          style={{
                            padding: '4px 10px',
                            fontSize: '9px',
                          }}
                        >
                          Re-Send For Listing Approval
                        </button>
                      </div>
                    )}

                    {/* LISTING APPROVAL REJECTED - CHECKER */}

                    {status === 'Listing Approval Rejected' && isChecker && (
                      <div className="mt-1">
                        {isExpanded && (
                          <>
                            <span className="text-danger d-block">
                              Listing Approval Rejected By {item.updated_by_name || 'Checker'}
                            </span>

                            <small className="text-muted d-block">Waiting for Maker Resubmission.</small>

                            {item.notes && <small className="text-muted d-block mt-1">Notes : {item.notes}</small>}

                            <button
                              className="btn btn-sm btn-dark mt-2"
                              onClick={() => navigate(`/dashboard/view-repo-checklist/${btoa(String(item.repo_id))}`)}
                              style={{
                                padding: '4px 10px',
                                fontSize: '9px',
                                textTransform: 'capitalize',
                              }}
                            >
                              View Checklist
                            </button>
                          </>
                        )}
                      </div>
                    )}

                    {/* PENDING CREDIT TEAM APPROVAL — Credit Ops (isChecker) */}
                    {status === 'Pending Credit Team Approval' && isChecker && (
                      <div className="mt-1">
                        {isExpanded && (
                          <small className="text-warning d-block mb-1">
                            Final Repair Submitted By {item.updated_by_name || item.created_by_name || 'User'}
                          </small>
                        )}

                        <div className="mb-1">
                          <button
                            type="button"
                            onClick={() => handleViewFinalRepairSubmission(item.repo_id)}
                            style={{
                              border: 'none',
                              background: 'transparent',
                              padding: '0',
                              color: '#0d6efd',
                              cursor: 'pointer',
                              fontSize: '12px',
                              fontWeight: '600',
                              textDecoration: 'underline',
                            }}
                          >
                            📄 View Final Repair Submission
                          </button>
                        </div>

                        <div className="d-flex gap-2">
                          <button
                            className="btn btn-sm btn-success"
                            style={{
                              height: '23px',
                              borderRadius: '5px',
                              padding: '5px 7px',
                              fontSize: '8.2px',
                              minWidth: '90px',
                            }}
                            onClick={() => handleOpenCreditFinalRepairAction(item.AgreementNo, 'approve')}
                          >
                            ✓ Accept
                          </button>
                          <button
                            className="btn btn-sm btn-danger"
                            style={{
                              height: '23px',
                              borderRadius: '5px',
                              padding: '5px 7px',
                              fontSize: '8.2px',
                              minWidth: '90px',
                            }}
                            onClick={() => handleOpenCreditFinalRepairAction(item.AgreementNo, 'reject')}
                          >
                            ✕ Reject
                          </button>
                        </div>
                      </div>
                    )}

                    {/* PENDING CREDIT TEAM APPROVAL — Maker / others waiting */}
                    {status === 'Pending Credit Team Approval' && !isChecker && (
                      <div className="mt-1">
                        {isExpanded && <span className="text-warning d-block">Waiting for Credit Team approval</span>}
                        <button
                          type="button"
                          onClick={() => handleViewFinalRepairSubmission(item.repo_id)}
                          style={{
                            border: 'none',
                            background: 'transparent',
                            padding: '0',
                            color: '#0d6efd',
                            cursor: 'pointer',
                            fontSize: '12px',
                            fontWeight: '600',
                            textDecoration: 'underline',
                          }}
                        >
                          📄 View Final Repair Submission
                        </button>
                      </div>
                    )}

                    {/* PENDING RH FINAL APPROVAL — Super Admin acts as RH for now */}
                    {status === 'Pending RH Final Approval' && isAdmin && (
                      <div className="mt-1">
                        {isExpanded && (
                          <small className="text-info d-block mb-1">
                            Sent to RH by {item.updated_by_name || 'Credit Team'}
                          </small>
                        )}

                        <div className="mb-1">
                          <button
                            type="button"
                            onClick={() => handleViewFinalRepairSubmission(item.repo_id)}
                            style={{
                              border: 'none',
                              background: 'transparent',
                              padding: '0',
                              color: '#0d6efd',
                              cursor: 'pointer',
                              fontSize: '12px',
                              fontWeight: '600',
                              textDecoration: 'underline',
                            }}
                          >
                            📄 View Final Repair Submission
                          </button>
                        </div>

                        <div className="d-flex gap-2">
                          <button
                            className="btn btn-sm btn-success"
                            style={{
                              height: '23px',
                              borderRadius: '5px',
                              padding: '5px 7px',
                              fontSize: '8.2px',
                              minWidth: '90px',
                            }}
                            onClick={() => handleOpenRHFinalRepairAction(item.AgreementNo, 'approve')}
                          >
                            ✓ Accept
                          </button>
                          <button
                            className="btn btn-sm btn-danger"
                            style={{
                              height: '23px',
                              borderRadius: '5px',
                              padding: '5px 7px',
                              fontSize: '8.2px',
                              minWidth: '90px',
                            }}
                            onClick={() => handleOpenRHFinalRepairAction(item.AgreementNo, 'reject')}
                          >
                            ✕ Reject
                          </button>
                        </div>
                      </div>
                    )}

                    {/* PENDING RH FINAL APPROVAL — Credit Ops / others: view only, waiting */}
                    {status === 'Pending RH Final Approval' && !isAdmin && (
                      <div className="mt-1">
                        {isExpanded && <span className="text-info d-block">Waiting for RH approval</span>}
                        <button
                          type="button"
                          onClick={() => handleViewFinalRepairSubmission(item.repo_id)}
                          style={{
                            border: 'none',
                            background: 'transparent',
                            padding: '0',
                            color: '#0d6efd',
                            cursor: 'pointer',
                            fontSize: '12px',
                            fontWeight: '600',
                            textDecoration: 'underline',
                          }}
                        >
                          📄 View Final Repair Submission
                        </button>
                      </div>
                    )}

                    {/* FINAL REPAIR APPROVED — Admin transfers to Finance Team */}
                    {status === 'Final Repair Approved' && isAdmin && (
                      <div className="mt-1">
                        {isExpanded && (
                          <span className="text-success d-block fw-bold">Final Repair Approved by RH</span>
                        )}
                        <button
                          type="button"
                          onClick={() => handleViewFinalRepairSubmission(item.repo_id)}
                          style={{
                            border: 'none',
                            background: 'transparent',
                            padding: '0',
                            color: '#0d6efd',
                            cursor: 'pointer',
                            fontSize: '12px',
                            fontWeight: '600',
                            textDecoration: 'underline',
                            display: 'block',
                            marginBottom: '6px',
                          }}
                        >
                          📄 View Final Repair Submission
                        </button>

                        <button
                          className="btn btn-sm btn-success"
                          style={{
                            height: '23px',
                            borderRadius: '5px',
                            padding: '5px 7px',
                            fontSize: '8.2px',
                            minWidth: '160px',
                            fontWeight: 'normal',
                          }}
                          onClick={() => handleOpenFinanceTransfer(item.AgreementNo, item.repo_id)}
                        >
                          ✓ Transfer to Finance Team
                        </button>
                      </div>
                    )}

                    {/* FINAL REPAIR APPROVED — everyone else, view only */}
                    {status === 'Final Repair Approved' && !isAdmin && (
                      <div className="mt-1">
                        {isExpanded && (
                          <span className="text-success d-block fw-bold">Final Repair Approved by RH</span>
                        )}
                        <button
                          type="button"
                          onClick={() => handleViewFinalRepairSubmission(item.repo_id)}
                          style={{
                            border: 'none',
                            background: 'transparent',
                            padding: '0',
                            color: '#0d6efd',
                            cursor: 'pointer',
                            fontSize: '12px',
                            fontWeight: '600',
                            textDecoration: 'underline',
                          }}
                        >
                          📄 View Final Repair Submission
                        </button>
                      </div>
                    )}

                    {/* PENDING FINANCE TEAM APPROVAL — Finance Team accepts */}
                    {status === 'Pending Finance Team Approval' && (isFinanceTeam || isAdmin) && (
                      <div className="mt-1">
                        {isExpanded && (
                          <small className="text-info d-block mb-1">
                            Sent to Finance Team by {item.updated_by_name || 'Admin'}
                          </small>
                        )}
                        <div className="mb-1">
                          <button
                            type="button"
                            onClick={() => handleViewFinalRepairSubmission(item.repo_id)}
                            style={{
                              border: 'none',
                              background: 'transparent',
                              padding: '0',
                              color: '#0d6efd',
                              cursor: 'pointer',
                              fontSize: '12px',
                              fontWeight: '600',
                              textDecoration: 'underline',
                            }}
                          >
                            📄 View Final Repair Submission
                          </button>
                        </div>

                        {item.notes && <small className="text-muted d-block mb-2">Notes: {item.notes}</small>}

                        <button
                          className="btn btn-sm btn-success"
                          style={{
                            height: '23px',
                            borderRadius: '5px',
                            padding: '5px 7px',
                            fontSize: '8.2px',
                            minWidth: '90px',
                          }}
                          onClick={() => handleOpenFinanceAccept(item.AgreementNo)}
                        >
                          ✓ Accept
                        </button>
                      </div>
                    )}

                    {/* PENDING FINANCE TEAM APPROVAL — others, waiting */}
                    {/* PENDING FINANCE TEAM APPROVAL — others, waiting */}
                    {status === 'Pending Finance Team Approval' && !isFinanceTeam && !isAdmin && (
                      <div className="mt-1">
                        {isExpanded && <span className="text-info d-block">Waiting for Finance Team approval</span>}

                        <button
                          type="button"
                          onClick={() => handleViewFinalRepairSubmission(item.repo_id)}
                          style={{
                            border: 'none',
                            background: 'transparent',
                            padding: '0',
                            color: '#0d6efd',
                            cursor: 'pointer',
                            fontSize: '12px',
                            fontWeight: '600',
                            textDecoration: 'underline',
                          }}
                        >
                          📄 View Final Repair Submission
                        </button>
                      </div>
                    )}

                    {/* PENDING FINANCE TEAM UPLOAD — Finance Team / Admin makes payment */}
                    {status === 'Pending Finance Team Upload' && (isFinanceTeam || isSubAccountent || isAdmin) && (
                      <div className="mt-1">
                        {isExpanded && (
                          <small className="text-warning d-block mb-1">
                            Accepted by {item.updated_by_name || 'Finance Team'}, payment pending
                          </small>
                        )}
                        <div className="mb-1">
                          <button
                            type="button"
                            onClick={() => handleViewFinalRepairSubmission(item.repo_id)}
                            style={{
                              border: 'none',
                              background: 'transparent',
                              padding: '0',
                              color: '#0d6efd',
                              cursor: 'pointer',
                              fontSize: '12px',
                              fontWeight: '600',
                              textDecoration: 'underline',
                            }}
                          >
                            📄 View Final Repair Submission
                          </button>
                        </div>

                        <button
                          className="btn btn-sm btn-primary"
                          style={{
                            height: '23px',
                            borderRadius: '5px',
                            padding: '5px 7px',
                            fontSize: '8.2px',
                            minWidth: '150px',
                          }}
                          onClick={() => handleOpenFinanceUpload(item.AgreementNo, item.repo_id)}
                        >
                          💳 Payment To Be Made
                        </button>
                      </div>
                    )}

                    {status === 'Payment Done' && (
                      <div className="mt-1">
                        {isExpanded && (
                          <>
                            <span className="text-success d-block fw-bold">Payment Done</span>
                            <small className="text-success d-block mt-1">
                              Uploaded By: {item.updated_by_name || 'Finance Team'}
                            </small>
                            {item.notes && <small className="text-muted d-block mt-1">Notes: {item.notes}</small>}
                          </>
                        )}
                        <button
                          type="button"
                          onClick={() => handleViewFinalRepairSubmission(item.repo_id)}
                          style={{
                            border: 'none',
                            background: 'transparent',
                            padding: '0',
                            color: '#0d6efd',
                            cursor: 'pointer',
                            fontSize: '12px',
                            fontWeight: '600',
                            textDecoration: 'underline',
                          }}
                        >
                          📄 View Payment Proof
                        </button>

                        <div className="mt-2 d-flex gap-2 flex-wrap">
                          <button
                            className="btn btn-sm btn-primary"
                            style={{
                              height: '23px',
                              borderRadius: '5px',
                              padding: '5px 7px',
                              fontSize: '8.2px',
                              minWidth: '140px',
                              fontWeight: 'normal',
                            }}
                            onClick={() => navigate(`/dashboard/schedule-inspection/${btoa(String(item.repo_id))}`)}
                          >
                            🚚 Yard Placement
                          </button>

                          <button
                            className="btn btn-sm btn-success"
                            style={{
                              height: '23px',
                              borderRadius: '5px',
                              padding: '5px 7px',
                              fontSize: '8.2px',
                              minWidth: '140px',
                              fontWeight: 'normal',
                            }}
                            onClick={() => handleViewPaymentProof(item.AgreementNo)}
                          >
                            💳 View Payment Bill
                          </button>
                        </div>
                      </div>
                    )}

                    {status === 'Pending Finance Team Upload' && !isFinanceTeam && !isAdmin && (
                      <div className="mt-1">
                        {isExpanded && <span className="text-warning d-block">Waiting for payment to be made</span>}
                        <button
                          type="button"
                          onClick={() => handleViewFinalRepairSubmission(item.repo_id)}
                          style={{
                            border: 'none',
                            background: 'transparent',
                            padding: '0',
                            color: '#0d6efd',
                            cursor: 'pointer',
                            fontSize: '12px',
                            fontWeight: '600',
                            textDecoration: 'underline',
                          }}
                        >
                          📄 View Final Repair Submission
                        </button>
                      </div>
                    )}

                    {status === 'Pending Finance Team Upload' && !isFinanceTeam && (
                      <div className="mt-1">
                        {isExpanded && <span className="text-warning d-block">Waiting for Finance Team upload</span>}
                        <button
                          type="button"
                          onClick={() => handleViewFinalRepairSubmission(item.repo_id)}
                          style={{
                            border: 'none',
                            background: 'transparent',
                            padding: '0',
                            color: '#0d6efd',
                            cursor: 'pointer',
                            fontSize: '12px',
                            fontWeight: '600',
                            textDecoration: 'underline',
                          }}
                        >
                          📄 View Final Repair Submission
                        </button>
                      </div>
                    )}

                    {/* FINANCE REPAIR COMPLETED */}
                    {status === 'Finance Repair Completed' && (
                      <div className="mt-1">
                        {isExpanded && <span className="text-success d-block fw-bold">Finance Process Completed</span>}
                        <button
                          type="button"
                          onClick={() => handleViewFinalRepairSubmission(item.repo_id)}
                          style={{
                            border: 'none',
                            background: 'transparent',
                            padding: '0',
                            color: '#0d6efd',
                            cursor: 'pointer',
                            fontSize: '12px',
                            fontWeight: '600',
                            textDecoration: 'underline',
                          }}
                        >
                          📄 View Final Repair Submission
                        </button>
                      </div>
                    )}

                    {status === 'Deal Locked' && (
                      <div className="mt-1">
                        {isExpanded && (
                          <>
                            <span
                              className="d-block"
                              style={{
                                color: '#198754',
                                fontWeight: '600',
                                fontSize: '12px',
                              }}
                            >
                              Deal Locked Successfully
                            </span>

                            <small className="text-muted d-block">
                              Submitted By : {item.updated_by_name || item.created_by_name || '-'}
                            </small>

                            {item.deal_amount && (
                              <small className="text-muted d-block">Deal Amount : ₹ {item.deal_amount}</small>
                            )}

                            {item.token_amount && (
                              <small className="text-muted d-block">Token Amount : ₹ {item.token_amount}</small>
                            )}

                            {item.notes && <small className="text-muted d-block">Notes : {item.notes}</small>}
                          </>
                        )}

                        <button
                          className="btn btn-sm btn-dark mt-2"
                          onClick={() => navigate(`/dashboard/view-repo-checklist/${btoa(String(item.repo_id))}`)}
                          style={{
                            padding: '4px 10px',
                            fontSize: '9px',
                          }}
                        >
                          View Checklist
                        </button>
                      </div>
                    )}

                    {status === 'Pending RH Approval' && isMaker && !isRH && (
                      <>
                        {isExpanded && (
                          <>
                            {item.notes && (
                              <div
                                style={{
                                  fontSize: '12px',
                                  color: '#0d6efd',
                                  marginBottom: '6px',
                                  fontWeight: '500',
                                }}
                              >
                                {item.notes}
                              </div>
                            )}
                            <button
                              className="btn btn-sm btn-dark mt-2"
                              onClick={() => {
                                navigate(`/dashboard/view-repo-checklist/${btoa(String(item.repo_id))}`);
                              }}
                              style={{
                                padding: '4px 10px',
                                fontSize: '9px',
                                textTransform: 'capitalize',
                              }}
                            >
                              View Checklist
                            </button>

                            <div className="mb-1">
                              <button
                                type="button"
                                onClick={() => handleViewRepairCost(item.repo_id)}
                                style={{
                                  border: 'none',
                                  background: 'transparent',
                                  padding: '0',
                                  color: '#6f42c1',
                                  cursor: 'pointer',
                                  fontSize: '12px',
                                  fontWeight: '600',
                                  textDecoration: 'underline',
                                }}
                              >
                                🔧 View Repair Cost
                              </button>
                            </div>

                            <div className="mb-2">
                              <button
                                type="button"
                                onClick={() => {
                                  handleViewRefurbishment(item.repo_id);
                                }}
                                style={{
                                  border: 'none',
                                  background: 'transparent',
                                  padding: '0',
                                  color: '#0d6efd',
                                  cursor: 'pointer',
                                  fontSize: '12px',
                                  fontWeight: '600',
                                  textDecoration: 'underline',
                                }}
                              >
                                View Refurbishment Details
                              </button>
                            </div>
                          </>
                        )}
                      </>
                    )}

                    {status === 'Pending RH Approval' && isRH && (
                      <>
                        {isExpanded && (
                          <>
                            {item.notes && (
                              <div
                                style={{
                                  fontSize: '12px',
                                  color: '#0d6efd',
                                  marginBottom: '6px',
                                  fontWeight: '500',
                                }}
                              >
                                {item.notes}
                              </div>
                            )}
                            <button
                              className="btn btn-sm btn-dark mt-2"
                              onClick={() => {
                                navigate(`/dashboard/view-repo-checklist/${btoa(String(item.repo_id))}`);
                              }}
                              style={{
                                padding: '4px 10px',
                                fontSize: '9px',
                                textTransform: 'capitalize',
                              }}
                            >
                              View Checklist
                            </button>

                            <div className="mb-1">
                              <button
                                type="button"
                                onClick={() => handleViewRepairCost(item.repo_id)}
                                style={{
                                  border: 'none',
                                  background: 'transparent',
                                  padding: '0',
                                  color: '#6f42c1',
                                  cursor: 'pointer',
                                  fontSize: '12px',
                                  fontWeight: '600',
                                  textDecoration: 'underline',
                                }}
                              >
                                🔧 View Repair Cost
                              </button>
                            </div>

                            {/* <div className="mb-2">
                              <button
                                type="button"
                                onClick={() => {
                                  handleViewRefurbishment(item.repo_id);
                                }}
                                style={{
                                  border: 'none',
                                  background: 'transparent',
                                  padding: '0',
                                  color: '#0d6efd',
                                  cursor: 'pointer',
                                  fontSize: '12px',
                                  fontWeight: '600',
                                  textDecoration: 'underline',
                                }}
                              >
                                View Refurbishment Details
                              </button>
                            </div> */}
                          </>
                        )}

                        <button
                          className="btn btn-sm btn-success me-2"
                          style={{
                            height: '23px',
                            borderRadius: '5px',
                            padding: '5px 7px',
                            fontSize: '8.2px',
                            minWidth: '90px',
                            fontWeight: 'normal',
                          }}
                          onClick={() => handleRHApprovalAction(item.AgreementNo, 'approve_rh')}
                        >
                          ✓ Accept
                        </button>

                        <button
                          className="btn btn-sm btn-danger"
                          style={{
                            height: '23px',
                            borderRadius: '5px',
                            padding: '5px 7px',
                            fontSize: '8.2px',
                            minWidth: '90px',
                            fontWeight: 'normal',
                          }}
                          onClick={() => handleRHApprovalAction(item.AgreementNo, 'reject_rh')}
                        >
                          ✕ Reject
                        </button>
                      </>
                    )}

                    {status === 'Pending RH Approval' &&
                      isChecker &&
                      (() => {
                        const totalCost = repairCostMap[item.repo_id];

                        const withinLimit =
                          totalCost !== undefined && repairCostLimit > 0 && totalCost <= repairCostLimit;

                        return (
                          <div className="mt-1">
                            {/* Ye details sirf accordion OPEN hone par dikhenge */}
                            {isExpanded && (
                              <>
                                <span
                                  className="text-warning d-block"
                                  style={{
                                    fontSize: '11px',
                                    fontWeight: '500',
                                    lineHeight: '1.5',
                                  }}
                                >
                                  Refurbishment Submitted By {item.updated_by_name || item.created_by_name || 'User'}
                                </span>

                                <small
                                  className="text-muted d-block"
                                  style={{
                                    fontSize: '12px',
                                    lineHeight: '1.4',
                                  }}
                                >
                                  Waiting for BH Approval.
                                </small>

                                <div className="mb-1">
                                  <button
                                    type="button"
                                    onClick={() => handleViewRepairCost(item.repo_id)}
                                    style={{
                                      border: 'none',
                                      background: 'transparent',
                                      padding: '0',
                                      color: '#6f42c1',
                                      cursor: 'pointer',
                                      fontSize: '12px',
                                      fontWeight: '600',
                                      textDecoration: 'underline',
                                    }}
                                  >
                                    🔧 View Repair Cost
                                  </button>
                                </div>

                                {/* Amount message only on open */}
                                {withinLimit && (
                                  <small className="text-success d-block mb-2">
                                    ✅ Amount within limit (₹{totalCost} ≤ ₹{repairCostLimit}) — you can approve
                                  </small>
                                )}
                              </>
                            )}

                            {/* Accept Reject ALWAYS visible */}
                            {withinLimit && (
                              <div className="d-flex align-items-center gap-2">
                                <button
                                  type="button"
                                  className="btn btn-sm btn-success"
                                  style={{
                                    height: '24px',
                                    borderRadius: '5px',
                                    padding: '5px 7px',
                                    fontSize: '8.2px',
                                    minWidth: '112px',
                                    fontWeight: 'normal',
                                  }}
                                  onClick={() => handleRHApprovalAction(item.AgreementNo, 'approve_rh')}
                                >
                                  ✓ ACCEPT
                                </button>

                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger"
                                  style={{
                                    height: '24px',
                                    borderRadius: '5px',
                                    padding: '5px 7px',
                                    fontSize: '8.2px',
                                    minWidth: '112px',
                                    fontWeight: 'normal',
                                  }}
                                  onClick={() => handleRHApprovalAction(item.AgreementNo, 'reject_rh')}
                                >
                                  ✕ REJECT
                                </button>
                              </div>
                            )}
                          </div>
                        );
                      })()}

                    {status === 'Pending RH Approval For Commercial Action' && isChecker && (
                      <>
                        <span className="text-info d-block">Commercial Approval sent to BH</span>

                        {isExpanded && (
                          <>
                            <small className="text-success d-block">
                              Sent by: {item.updated_by_name || item.created_by_name || 'User'}
                            </small>

                            {item.notes && <small className="text-muted d-block mt-1">Notes: {item.notes}</small>}

                            <small className="text-muted d-block mt-1">Waiting for BH approval or rejection.</small>

                            <div className="mb-1">
                              <button
                                type="button"
                                onClick={() => handleViewRepairCost(item.repo_id)}
                                style={{
                                  border: 'none',
                                  background: 'transparent',
                                  padding: '0',
                                  color: '#6f42c1',
                                  cursor: 'pointer',
                                  fontSize: '12px',
                                  fontWeight: '600',
                                  textDecoration: 'underline',
                                }}
                              >
                                🔧 View Repair Cost
                              </button>
                            </div>
                          </>
                        )}
                      </>
                    )}

                    {status === 'Pending RH Approval For Commercial Action' && isMaker && (
                      <>
                        {isExpanded && (
                          <>
                            <div
                              style={{
                                fontSize: '12px',
                                color: '#0d6efd',
                                marginBottom: '6px',
                                fontWeight: '500',
                              }}
                            >
                              Commercial Approval sent by {item.updated_by_name || item.created_by_name || 'User'}
                            </div>

                            {item.notes && (
                              <div
                                style={{
                                  fontSize: '12px',
                                  color: '#6c757d',
                                  marginBottom: '6px',
                                }}
                              >
                                {item.notes}
                              </div>
                            )}

                            <div className="mb-1">
                              <button
                                type="button"
                                onClick={() => handleViewRepairCost(item.repo_id)}
                                style={{
                                  border: 'none',
                                  background: 'transparent',
                                  padding: '0',
                                  color: '#6f42c1',
                                  cursor: 'pointer',
                                  fontSize: '12px',
                                  fontWeight: '600',
                                  textDecoration: 'underline',
                                }}
                              >
                                🔧 View Repair Cost
                              </button>
                            </div>
                          </>
                        )}

                        <button
                          className="btn btn-sm btn-success me-2"
                          style={{
                            height: '23px',
                            borderRadius: '5px',
                            padding: '5px 7px',
                            fontSize: '8.2px',
                            minWidth: '90px',
                            fontWeight: 'normal',
                          }}
                          onClick={() => handleCommercialApprovalAction(item.AgreementNo, 'approve', item.repo_id)}
                        >
                          ✓ Accept
                        </button>

                        <button
                          className="btn btn-sm btn-danger"
                          style={{
                            height: '23px',
                            borderRadius: '5px',
                            padding: '5px 7px',
                            fontSize: '8.2px',
                            minWidth: '90px',
                            fontWeight: 'normal',
                          }}
                          onClick={() => handleCommercialApprovalAction(item.AgreementNo, 'reject', item.repo_id)}
                        >
                          ✕ Reject
                        </button>
                      </>
                    )}

                    {/* APPROVED — Maker uploads court order file */}
                    {status === 'Approved' && (isMaker || isAdmin) && (
                      <div className="mt-1">
                        {uploadingId === item.AgreementNo ? (
                          <div>
                            <input
                              type="file"
                              className="form-control form-control-sm mb-1"
                              accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
                              onChange={(e) =>
                                setFiles((prev) => ({
                                  ...prev,
                                  [item.AgreementNo]: e.target.files[0],
                                }))
                              }
                            />
                            <button
                              className="btn btn-sm btn-success me-1"
                              onClick={() => handleUploadCourtOrder(item.AgreementNo)}
                            >
                              Upload
                            </button>
                            <button className="btn btn-sm btn-secondary" onClick={() => setUploadingId(null)}>
                              Cancel
                            </button>
                          </div>
                        ) : (
                          <button
                            className="btn btn-sm btn-primary"
                            style={{
                              padding: '4px 10px',
                              fontSize: '9px',
                              textTransform: 'capitalize',
                            }}
                            onClick={() => setUploadingId(item.AgreementNo)}
                          >
                            Upload Court Order
                          </button>
                        )}
                      </div>
                    )}

                    {/* PENDING FOR COURT ORDER REVIEW — Checker downloads, Maker waits */}
                    {status === 'Pending for Court Order Review' && isChecker && (
                      <div className="d-flex flex-column gap-1">
                        <small className="text-primary d-block mb-1">
                          Sent for Court Order Approval by{' '}
                          {item.updated_by_name && item.notes ? item.updated_by_name : item.created_by_name || 'User'}
                        </small>

                        <button
                          type="button"
                          onClick={() => handleDownloadCourtOrder(item.court_order_file)}
                          style={{
                            border: 'none',
                            background: 'transparent',
                            padding: '0',
                            width: 'fit-content',
                            color: '#0dcaf0',
                            cursor: 'pointer',
                            fontSize: '13px',
                            fontWeight: '600',
                            textDecoration: 'underline',
                          }}
                        >
                          ⬇ Download Court Order
                        </button>

                        {item.notes && (
                          <button
                            type="button"
                            title="View re-upload notes from maker"
                            onClick={() => {
                              setViewNotesContent(item.notes);
                              setShowViewNotesModal(true);
                            }}
                            style={{
                              border: 'none',
                              background: 'transparent',
                              padding: '0',
                              width: 'fit-content',
                              color: '#6c757d',
                              cursor: 'pointer',
                              fontSize: '12px',
                              fontWeight: '500',
                              textDecoration: 'underline',
                            }}
                          >
                            👁 View Notes
                          </button>
                        )}

                        <button
                          className="btn btn-success btn-sm"
                          style={{
                            padding: '4px 10px',
                            fontSize: '9px',
                            textTransform: 'capitalize',
                          }}
                          onClick={() => handleCourtOrderAction(item.AgreementNo, 'approve')}
                        >
                          ✓ Approve Court Order
                        </button>

                        <button
                          className="btn btn-danger btn-sm"
                          style={{
                            padding: '4px 10px',
                            fontSize: '9px',
                            textTransform: 'capitalize',
                          }}
                          onClick={() => handleCourtOrderAction(item.AgreementNo, 'reject')}
                        >
                          ✕ Reject Court Order
                        </button>
                      </div>
                    )}

                    {status === 'Pending for Court Order Review' && !isChecker && isExpanded && (
                      <span className="text-warning d-block mt-1">Waiting for Court Order Approval</span>
                    )}

                    {/* {status === "Court Order Approved" && !isChecker && (
                    <div className="mt-1">
                      {isExpanded && (
                        <>
                          <span className="text-success d-block">
                            Court Order Approved by{" "}
                            {item.updated_by_name || "Credit Operations"}
                          </span>

                          <small className="text-muted d-block mt-1">
                            Notes: {item.notes}
                          </small>
                        </>
                      )}

                      <button
                        className="btn btn-sm btn-primary mt-2"
                            onClick={() => {

                        if (
                          !allowedRepoUsers.includes(
                            userRole?.toLowerCase()
                          )
                        ) {

                          toast.error("Access Denied");

                          return;
                        }

                        navigate(
                          `/dashboard/create-vehicle-repo/${btoa(String(item.AgreementNo))}`
                        );

                      }}
                      style={{
                          padding: "4px 10px",
                          fontSize: "9px",
                          textTransform: "capitalize"
                        }}
                      >
                        START REPO PROCESS
                      </button>

                    </div>
                    )} */}
                    {status === 'Court Order Approved' && (
                      <div className="mt-1">
                        {isExpanded && (
                          <>
                            <span className="text-success d-block">
                              Court Order Uploaded by {item.updated_by_name || 'Credit Operations'}
                            </span>
                            {item.notes?.length > 0 && (
                              <small className="text-muted d-block mt-1">Notes: {item.notes}</small>
                            )}

                            {/* 👇 NAYA — chhote View LNR / View Section 9 buttons */}
                            <div className="d-flex flex-wrap gap-1 mt-2">
                              {item.lnr_document && (
                                <a
                                  href={config.API_BASE_URL + item.lnr_document}
                                  target="_blank"
                                  rel="noreferrer"
                                  className="btn btn-sm"
                                  style={{
                                    padding: '3px 8px',
                                    fontSize: '8.5px',
                                    fontWeight: 700,
                                    backgroundColor: '#16a34a',
                                    color: '#fff',
                                    borderRadius: '5px',
                                    textDecoration: 'none',
                                  }}
                                  title={`Uploaded by ${item.lnr_uploaded_by_name || 'Legal Team'}`}
                                >
                                  ⬇ View LNR
                                </a>
                              )}

                              {item.section9_final_document && (
                                <a
                                  href={config.API_BASE_URL + item.section9_final_document}
                                  target="_blank"
                                  rel="noreferrer"
                                  className="btn btn-sm"
                                  style={{
                                    padding: '3px 8px',
                                    fontSize: '8.5px',
                                    fontWeight: 700,
                                    backgroundColor: '#2563eb',
                                    color: '#fff',
                                    borderRadius: '5px',
                                    textDecoration: 'none',
                                  }}
                                  title={`Uploaded by ${item.section9_uploaded_by_name || 'Legal Team'}`}
                                >
                                  ⬇ View Section 9
                                </a>
                              )}
                            </div>
                          </>
                        )}

                        <div className="d-flex flex-column" style={{ gap: '4px', marginTop: '6px' }}>
                          {/* Sirf Maker ke liye */}
                          {!isChecker && (
                            <button
                              className="btn btn-sm btn-primary"
                              onClick={() => {
                                if (!allowedRepoUsers.includes(userRole?.toLowerCase())) {
                                  toast.error('Access Denied');
                                  return;
                                }

                                navigate(`/dashboard/create-vehicle-repo/${btoa(String(item.AgreementNo))}`);
                              }}
                              style={{
                                height: '23px',
                                borderRadius: '5px',
                                padding: '5px 7px',
                                fontSize: '8.2px',
                                minWidth: '150px',
                                fontWeight: 'normal',
                              }}
                            >
                              START REPO PROCESS
                            </button>
                          )}

                          {/* Maker + Checker dono ke liye */}
                          <button
                            className="btn btn-sm btn-success"
                            onClick={() => {
                              navigate(`/dashboard/generate-pre-intimation/${btoa(String(item.AgreementNo))}`);
                            }}
                            style={{
                              height: '23px',
                              borderRadius: '5px',
                              padding: '5px 7px',
                              fontSize: '8.2px',
                              minWidth: '150px',
                              fontWeight: 'normal',
                            }}
                          >
                            GENERATE PRE-INTIMATION LETTER
                          </button>
                        </div>
                      </div>
                    )}

                    {status === 'Repo Initiated' && !isChecker && (
                      <div className="mt-1">
                        {isExpanded && (
                          <>
                            <span className="text-info d-block">Repo process initiated successfully</span>
                            <small className="text-success d-block mt-1">
                              Submitted By: {item.updated_by_name || 'User'}
                            </small>

                            <small className="text-muted d-block mt-1">Notes: {item.notes}</small>
                          </>
                        )}

                        <button
                          className="btn btn-sm btn-dark mt-2"
                          onClick={() => {
                            if (!allowedRepoUsers.includes(userRole?.toLowerCase())) {
                              toast.error('Access Denied');

                              return;
                            }

                            navigate(`/dashboard/repo-conditions-checklist/${btoa(String(item.repo_id))}`);
                          }}
                          style={{
                            padding: '4px 10px',
                            fontSize: '9px',
                            textTransform: 'capitalize',
                          }}
                        >
                          OPEN REPO CHECKLIST
                        </button>
                      </div>
                    )}
                    {status === 'Repo Initiated' && isChecker && (
                      <div className="mt-1">
                        <span
                          className="text-info d-block"
                          style={{
                            fontSize: '14px',
                            fontWeight: '600',
                            lineHeight: '1.5',
                          }}
                        >
                          Repo Initiated by Sales Team
                        </span>

                        <small
                          className="text-muted d-block"
                          style={{
                            fontSize: '12px',
                            lineHeight: '1.4',
                          }}
                        >
                          Waiting for Repo Checklist submission by the Sales Team.
                        </small>
                      </div>
                    )}
                    {status === 'Repo Checklist Submitted' && !isChecker && (
                      <div className="mt-1">
                        {isExpanded && (
                          <>
                            <span className="text-success d-block">Repo checklist submitted successfully</span>

                            <small className="text-success d-block mt-1">
                              Submitted By: {item.updated_by_name || 'User'}
                            </small>

                            <small className="text-muted d-block mt-1">Inspection / Yard placement pending</small>
                          </>
                        )}

                        <div className="d-flex gap-2 flex-wrap mt-2">
                          <button
                            className="btn btn-sm btn-dark"
                            onClick={() => {
                              navigate(`/dashboard/view-repo-checklist/${btoa(String(item.repo_id))}`);
                            }}
                            style={{
                              padding: '4px 10px',
                              fontSize: '9px',
                              textTransform: 'capitalize',
                            }}
                          >
                            View Checklist
                          </button>

                          <button
                            className="btn btn-sm btn-primary"
                            onClick={() => {
                              if (!allowedRepoUsers.includes(userRole?.toLowerCase())) {
                                toast.error('Access Denied');
                                return;
                              }

                              navigate(`/dashboard/schedule-inspection/${btoa(String(item.repo_id))}`);
                            }}
                            style={{
                              padding: '4px 10px',
                              fontSize: '9px',
                              textTransform: 'capitalize',
                            }}
                          >
                            Open Schedule Inspection
                          </button>
                        </div>
                      </div>
                    )}

                    {status === 'Inspection Scheduled' && !isChecker && (
                      <div className="mt-1">
                        {isExpanded && (
                          <>
                            <span className="text-info d-block">Inspection & Yard placement scheduled</span>

                            <small className="text-success d-block mt-1">
                              Submitted By: {item.updated_by_name || 'User'}
                            </small>

                            <small className="text-muted d-block mt-1">Yard inspection scheduled successfully</small>
                          </>
                        )}

                        <div className="d-flex gap-2 flex-wrap mt-2">
                          <button
                            className="btn btn-sm btn-dark"
                            onClick={() => {
                              navigate(`/dashboard/view-repo-checklist/${btoa(String(item.repo_id))}`);
                            }}
                            style={{
                              padding: '4px 10px',
                              fontSize: '9px',
                              textTransform: 'capitalize',
                            }}
                          >
                            View Checklist
                          </button>

                          <button
                            className="btn btn-sm btn-info text-white"
                            onClick={() => {
                              navigate(`/dashboard/schedule-inspection/${btoa(String(item.repo_id))}`);
                            }}
                            style={{
                              padding: '4px 10px',
                              fontSize: '9px',
                              textTransform: 'capitalize',
                            }}
                          >
                            Open Inspection
                          </button>
                        </div>
                      </div>
                    )}
                    {status === 'Inventory Created' && !isChecker && (
                      <div className="mt-1">
                        {isExpanded && (
                          <>
                            <span className="text-dark d-block">Final inventory created successfully</span>

                            <small className="text-success d-block mt-1">
                              Submitted By: {item.updated_by_name || 'User'}
                            </small>

                            <small className="text-muted d-block mt-1">Notes: {item.notes}</small>
                          </>
                        )}

                        <div className="d-flex gap-2 flex-wrap mt-2">
                          <button
                            className="btn btn-sm btn-dark"
                            onClick={() => {
                              navigate(`/dashboard/view-repo-checklist/${btoa(String(item.repo_id))}`);
                            }}
                            style={{
                              padding: '4px 10px',
                              fontSize: '9px',
                              textTransform: 'capitalize',
                            }}
                          >
                            View Checklist
                          </button>

                          <button
                            className="btn btn-sm btn-secondary"
                            onClick={() => {
                              handleViewInventory(item.AgreementNo);
                            }}
                            style={{
                              padding: '4px 10px',
                              fontSize: '9px',
                              textTransform: 'capitalize',
                            }}
                          >
                            View Inventory
                          </button>
                        </div>
                      </div>
                    )}

                    {status === 'Repair Approved' && !isChecker && (
                      <div className="mt-1">
                        {isExpanded && (
                          <>
                            <span className="text-success d-block">Repair Approved by BH</span>
                            <small className="text-success d-block mt-1">
                              Submitted By: {item.updated_by_name || 'User'}
                            </small>
                            <small className="text-muted d-block mt-1">Ready for Commercial Approval.</small>

                            <div className="mb-1">
                              <button
                                type="button"
                                onClick={() => handleViewRepairCost(item.repo_id)}
                                style={{
                                  border: 'none',
                                  background: 'transparent',
                                  padding: '0',
                                  color: '#6f42c1',
                                  cursor: 'pointer',
                                  fontSize: '12px',
                                  fontWeight: '600',
                                  textDecoration: 'underline',
                                }}
                              >
                                🔧 View Repair Cost
                              </button>
                            </div>
                          </>
                        )}

                        <div className="d-flex gap-2 flex-wrap mt-2">
                          <button
                            className="btn btn-sm btn-primary"
                            onClick={() => handleOpenFinalRepairModal(item.AgreementNo, item.repo_id)}
                            style={{
                              padding: '4px 10px',
                              fontSize: '9px',
                              textTransform: 'capitalize',
                            }}
                          >
                            🛠 Is Repair Done
                          </button>

                          <button
                            className="btn btn-sm btn-dark"
                            onClick={() => navigate(`/dashboard/view-repo-checklist/${btoa(String(item.repo_id))}`)}
                            style={{
                              padding: '4px 10px',
                              fontSize: '9px',
                              textTransform: 'capitalize',
                            }}
                          >
                            View Checklist
                          </button>
                        </div>
                      </div>
                    )}

                    {status === 'Repair Approved' && isChecker && (
                      <div className="mt-1">
                        {isExpanded && (
                          <>
                            <span className="text-success d-block">Repair Approved by RH</span>

                            <small className="text-success d-block mt-1">
                              Submitted By: {item.updated_by_name || 'User'}
                            </small>
                          </>
                        )}

                        <button
                          className="btn btn-sm btn-dark mt-2"
                          onClick={() => navigate(`/dashboard/view-repo-checklist/${btoa(String(item.repo_id))}`)}
                          style={{
                            padding: '4px 10px',
                            fontSize: '9px',
                            textTransform: 'capitalize',
                          }}
                        >
                          View Checklist
                        </button>

                        <div className="mb-1">
                          <button
                            type="button"
                            onClick={() => handleViewRepairCost(item.repo_id)}
                            style={{
                              border: 'none',
                              background: 'transparent',
                              padding: '0',
                              color: '#6f42c1',
                              cursor: 'pointer',
                              fontSize: '12px',
                              fontWeight: '600',
                              textDecoration: 'underline',
                            }}
                          >
                            🔧 View Repair Cost
                          </button>
                        </div>
                      </div>
                    )}

                    {status === 'Court Order Rejected' && !isChecker && (
                      <div className="mt-1">
                        {isExpanded && (
                          <>
                            <span className="text-danger d-block">
                              Court Order Rejected by {item.updated_by_name || 'Credit Operations'}
                            </span>

                            <small className="text-muted d-block mt-1">Notes: {item.notes}</small>
                          </>
                        )}

                        {uploadingId === item.AgreementNo ? (
                          <div className="mt-2">
                            <input
                              type="file"
                              className="form-control form-control-sm mb-1"
                              accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
                              onChange={(e) =>
                                setFiles((prev) => ({
                                  ...prev,
                                  [item.AgreementNo]: e.target.files[0],
                                }))
                              }
                            />

                            <button
                              className="btn btn-sm btn-success me-1"
                              onClick={() => handleUploadCourtOrder(item.AgreementNo)}
                            >
                              Upload
                            </button>

                            <button className="btn btn-sm btn-secondary" onClick={() => setUploadingId(null)}>
                              Cancel
                            </button>
                          </div>
                        ) : (
                          <button
                            className="btn btn-sm btn-warning mt-2"
                            style={{
                              padding: '4px 10px',
                              fontSize: '9px',
                              textTransform: 'capitalize',
                            }}
                            onClick={() => handleReuploadCourtOrder(item.AgreementNo)}
                          >
                            Re-Upload Court Order
                          </button>
                        )}
                      </div>
                    )}

                    {status === 'Vehicle Surrender' && isChecker && (
                      <div className="mt-1">
                        {isExpanded && (
                          <>
                            <span className="text-danger d-block fw-bold">Vehicle Surrendered</span>

                            <small className="text-success d-block mt-1">
                              Submitted By: {item.updated_by_name || item.created_by_name || 'User'}
                            </small>

                            <small className="text-muted d-block mt-1">Notes:</small>

                            <div
                              className="border rounded p-2 mt-1"
                              style={{
                                background: '#f8f9fa',
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'break-word',
                              }}
                            >
                              {expandedSurrenderNotes[item.id]
                                ? item.notes || 'No notes available'
                                : (item.notes || 'No notes available').length > 120
                                ? `${(item.notes || 'No notes available').substring(0, 120)}...`
                                : item.notes || 'No notes available'}

                              {(item.notes || '').length > 120 && (
                                <div>
                                  <button
                                    type="button"
                                    onClick={() =>
                                      setExpandedSurrenderNotes((prev) => ({
                                        ...prev,
                                        [item.id]: !prev[item.id],
                                      }))
                                    }
                                    style={{
                                      color: '#0d6efd',
                                      cursor: 'pointer',
                                      fontWeight: '600',
                                      fontSize: '12px',
                                      border: 'none',
                                      background: 'transparent',
                                      padding: 0,
                                      marginTop: '4px',
                                    }}
                                  >
                                    {expandedSurrenderNotes[item.id] ? 'Show Less' : 'Show More'}
                                  </button>
                                </div>
                              )}
                            </div>
                          </>
                        )}
                      </div>
                    )}
                    {status === 'Vehicle Surrender' && (
                      <div className="mt-1">
                        {isExpanded && (
                          <>
                            <span className="text-danger d-block fw-bold">Vehicle Surrendered</span>

                            <small className="text-success d-block mt-1">
                              Submitted By: {item.updated_by_name || item.created_by_name || 'User'}
                            </small>

                            <small className="text-muted d-block mt-1">Notes:</small>

                            <div
                              className="border rounded p-2 mt-1"
                              style={{
                                background: '#f8f9fa',
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'break-word',
                              }}
                            >
                              {expandedSurrenderNotes[item.id]
                                ? item.notes || 'No notes available'
                                : (item.notes || 'No notes available').length > 120
                                ? `${(item.notes || 'No notes available').substring(0, 120)}...`
                                : item.notes || 'No notes available'}

                              {(item.notes || '').length > 120 && (
                                <div>
                                  <button
                                    type="button"
                                    onClick={() =>
                                      setExpandedSurrenderNotes((prev) => ({
                                        ...prev,
                                        [item.id]: !prev[item.id],
                                      }))
                                    }
                                    style={{
                                      color: '#0d6efd',
                                      cursor: 'pointer',
                                      fontWeight: '600',
                                      fontSize: '12px',
                                      border: 'none',
                                      background: 'transparent',
                                      padding: 0,
                                      marginTop: '4px',
                                    }}
                                  >
                                    {expandedSurrenderNotes[item.id] ? 'Show Less' : 'Show More'}
                                  </button>
                                </div>
                              )}
                            </div>
                          </>
                        )}

                        {(isMaker || isChecker || isAdmin) && (
                          <button
                            className="btn btn-sm btn-primary mt-2"
                            onClick={() => {
                              navigate(`/dashboard/create-vehicle-repo/${btoa(String(item.AgreementNo))}`);
                            }}
                            style={{
                              height: '23px',
                              borderRadius: '5px',
                              padding: '5px 7px',
                              fontSize: '8.2px',
                              minWidth: '180px',
                              fontWeight: 'normal',
                            }}
                          >
                            INITIATE SURRENDER CHECKLIST
                          </button>
                        )}
                      </div>
                    )}

                    {status === 'Ready For Listing Approval' && !isChecker && (
                      <div className="mt-1">
                        {/* Always Visible */}
                        {/* <button
                        className="btn btn-sm btn-warning"
                        onClick={() =>
                          navigate(
                            `/dashboard/final-submission/${btoa(
                              String(item.repo_id)
                            )}`
                          )
                        }
                        style={{
                          padding: "4px 10px",
                          fontSize: "9px",
                          textTransform: "capitalize"
                        }}
                      >
                        Send For Listing Approval
                      </button> */}

                        <button
                          className="btn btn-sm btn-warning"
                          onClick={() => handleListingApprovalOpen(item.AgreementNo, item.repo_id)}
                          style={{
                            padding: '4px 10px',
                            fontSize: '9px',
                            textTransform: 'capitalize',
                          }}
                        >
                          Send For Listing Approval
                        </button>

                        {/* Show only when accordion is expanded */}
                        {isExpanded && (
                          <>
                            <span className="text-warning d-block mt-2">Vehicle is ready for listing approval</span>

                            <small className="text-success d-block mt-1">
                              Submitted By: {item.updated_by_name || 'User'}
                            </small>

                            <small className="text-muted d-block mt-1">Notes: {item.notes || '-'}</small>

                            <div className="d-flex gap-2 flex-wrap mt-2">
                              <button
                                className="btn btn-sm btn-dark"
                                onClick={() => navigate(`/dashboard/view-repo-checklist/${btoa(String(item.repo_id))}`)}
                                style={{
                                  padding: '4px 10px',
                                  fontSize: '9px',
                                  textTransform: 'capitalize',
                                }}
                              >
                                View Checklist
                              </button>

                              <button
                                className="btn btn-sm btn-secondary"
                                onClick={() => handleViewInventory(item.AgreementNo)}
                                style={{
                                  padding: '4px 10px',
                                  fontSize: '9px',
                                  textTransform: 'capitalize',
                                }}
                              >
                                View Inventory
                              </button>
                            </div>
                          </>
                        )}
                      </div>
                    )}

                    {status === 'Ready For Listing Approval' && (
                      <div className="mt-1">
                        {/* Sab users ko visible */}
                        <button
                          className="btn btn-sm btn-success"
                          onClick={() => {
                            navigate(`/dashboard/generate-post-sell-letter/${btoa(String(item.AgreementNo))}`);
                          }}
                          style={{
                            height: '23px',
                            borderRadius: '5px',
                            padding: '5px 7px',
                            fontSize: '8.2px',
                            minWidth: '170px',
                            fontWeight: 'normal',
                          }}
                        >
                          GENERATE POST SELL LETTER
                        </button>

                        {/* Accordion Open hone par */}
                        {isExpanded && (
                          <>
                            <span
                              className="text-warning d-block mt-2"
                              style={{
                                fontSize: '11px',
                                fontWeight: '500',
                              }}
                            >
                              Final Submission Submitted By {item.updated_by_name || item.created_by_name || 'User'}
                            </span>

                            <small
                              className="text-muted d-block"
                              style={{
                                fontSize: '12px',
                              }}
                            >
                              Ready For Listing Initiated By Sales Team.
                            </small>

                            {isChecker && (
                              <button
                                className="btn btn-sm btn-dark mb-2"
                                onClick={() => {
                                  navigate(`/dashboard/view-repo-checklist/${btoa(String(item.repo_id))}`);
                                }}
                                style={{
                                  padding: '4px 10px',
                                  fontSize: '9px',
                                  textTransform: 'capitalize',
                                }}
                              >
                                View Checklist
                              </button>
                            )}
                          </>
                        )}
                      </div>
                    )}

                    {status === 'Pending Listing Approval' && !isChecker && (
                      <>
                        {isExpanded && (
                          <>
                            <small className="text-primary d-block">
                              Listing Approval Request Sent By {item.updated_by_name || item.created_by_name || 'User'}
                            </small>

                            <small className="text-muted d-block mt-1">Notes: {item.notes || '-'}</small>
                            <button
                              className="btn btn-sm btn-dark mt-2"
                              onClick={() => {
                                navigate(`/dashboard/view-repo-checklist/${btoa(String(item.repo_id))}`);
                              }}
                              style={{
                                padding: '4px 10px',
                                fontSize: '9px',
                                textTransform: 'capitalize',
                              }}
                            >
                              View Checklist
                            </button>
                          </>
                        )}
                      </>
                    )}

                    {status === 'Pending Listing Amount Approval' && isChecker && (
                      <>
                        {isExpanded && (
                          <>
                            <small className="text-success d-block mb-1">
                              Listing Amount Sent By {item.updated_by_name || item.created_by_name || 'User'}
                            </small>

                            <button
                              type="button"
                              onClick={() => handleViewListingAmountDetails(item.AgreementNo)}
                              style={{
                                border: 'none',
                                background: 'transparent',
                                padding: '0',
                                color: '#6f42c1',
                                cursor: 'pointer',
                                fontSize: '12px',
                                fontWeight: '600',
                                textDecoration: 'underline',
                                display: 'block',
                                marginBottom: '6px',
                              }}
                            >
                              💰 View Listing Amount
                            </button>

                            <small className="text-muted d-block mb-2">
                              <strong>Notes:</strong> {item.notes || '-'}
                            </small>
                          </>
                        )}

                        <button
                          className="btn btn-sm btn-success me-2"
                          style={{
                            height: '23px',
                            borderRadius: '5px',
                            padding: '5px 7px',
                            fontSize: '8.2px',
                            minWidth: '90px',
                            fontWeight: 'normal',
                          }}
                          onClick={() => handleListingAmountApprovalOpen(item.AgreementNo, 'approve')}
                        >
                          ✓ Accept
                        </button>

                        <button
                          className="btn btn-sm btn-danger"
                          style={{
                            height: '23px',
                            borderRadius: '5px',
                            padding: '5px 7px',
                            fontSize: '8.2px',
                            minWidth: '90px',
                            fontWeight: 'normal',
                          }}
                          onClick={() => handleListingAmountApprovalOpen(item.AgreementNo, 'reject')}
                        >
                          ✕ Reject
                        </button>
                      </>
                    )}

                    {status === 'Pending Listing Amount Approval' && isMaker && (
                      <div className="mt-1">
                        {isExpanded && (
                          <>
                            <small className="text-primary d-block">
                              Listing Amount Request Sent By {item.updated_by_name || item.created_by_name || 'User'}
                            </small>

                            {item.listing_amount && (
                              <small className="text-muted d-block mt-1">
                                <strong>Listing Amount :</strong> ₹ {item.listing_amount}
                              </small>
                            )}

                            <small className="text-muted d-block mt-1">Notes: {item.notes || '-'}</small>
                          </>
                        )}
                      </div>
                    )}

                    {/* VIEW COMPLETE REPO DETAILS */}
                    {isMaker && item.repo_id && (
                      <div className="mt-2">
                        <button
                          type="button"
                          onClick={() => handleViewRepoDetails(item.AgreementNo)}
                          style={{
                            border: 'none',
                            background: 'transparent',
                            padding: '0',
                            color: '#0d6efd',
                            cursor: 'pointer',
                            fontSize: '13px',
                            fontWeight: '500',
                            textDecoration: 'underline',
                          }}
                        >
                          View Complete Repo Details
                        </button>
                      </div>
                    )}
                  </td>
                  <td onClick={(e) => e.stopPropagation()}>
                    <button
                      className="btn btn-sm btn-dark"
                      style={{
                        padding: '4px 10px',
                        fontSize: '9px',
                        textTransform: 'capitalize',
                      }}
                      onClick={() => handleViewActivities(item.AgreementNo)}
                    >
                      👁 View
                    </button>

                    {/* <button
                      className="btn btn-sm btn-info mt-1"
                      style={{
                        padding: '4px 10px',
                        fontSize: '9px',
                        textTransform: 'capitalize',
                      }}
                      onClick={() => handleStaticFlowModal(item)}
                    >
                      View Progress
                    </button> */}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* PAGINATION */}
      <nav>
        <ul className="pagination justify-content-end">
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
            <li className="page-item" key={p}>
              <button className="page-link" onClick={() => setPage(p)} disabled={page === p}>
                {p}
              </button>
            </li>
          ))}
        </ul>
      </nav>

      {showReuploadModal && (
        <div className="modal d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Re-Upload Court Order</h5>

                <button type="button" className="btn-close" onClick={() => setShowReuploadModal(false)} />
              </div>

              <div className="modal-body">
                <label className="form-label fw-bold">Upload File</label>

                <input
                  type="file"
                  className="form-control mb-3"
                  accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
                  onChange={(e) =>
                    setFiles((prev) => ({
                      ...prev,
                      [reuploadAgreement]: e.target.files[0],
                    }))
                  }
                />

                <label className="form-label fw-bold">Notes</label>

                <textarea
                  className="form-control"
                  rows="4"
                  placeholder="Enter re-upload reason..."
                  value={resendNotes}
                  onChange={(e) => setResendNotes(e.target.value)}
                />
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowReuploadModal(false)}>
                  Cancel
                </button>

                {/* --- PRELOADER: Submit button disabled while POST is in-flight --- */}
                <button
                  className="btn btn-warning"
                  onClick={submitReuploadCourtOrder}
                  disabled={postLoading}
                  style={{ opacity: postLoading ? 0.7 : 1 }}
                >
                  {postLoading ? 'Submitting...' : 'Submit'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showNotesModal && (
        <div className="modal d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {selectedAction === 'approve' ? 'Approve Court Order' : 'Reject Court Order'}
                </h5>

                <button type="button" className="btn-close" onClick={() => setShowNotesModal(false)} />
              </div>

              <div className="modal-body">
                <label className="form-label fw-bold">Notes</label>

                <textarea
                  className="form-control"
                  rows="4"
                  placeholder="Enter notes..."
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                />
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowNotesModal(false)}>
                  Cancel
                </button>

                {/* --- PRELOADER: Submit button disabled while POST is in-flight --- */}
                <button
                  className={`btn ${selectedAction === 'approve' ? 'btn-success' : 'btn-danger'}`}
                  onClick={submitCourtOrderAction}
                  disabled={postLoading}
                  style={{ opacity: postLoading ? 0.7 : 1 }}
                >
                  {postLoading ? 'Submitting...' : 'Submit'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showRHApprovalModal && (
        <div className="modal d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {rhActionType === 'approve_rh' ? 'Approve Refurbishment' : 'Reject Refurbishment'}
                </h5>

                <button type="button" className="btn-close" onClick={() => setShowRHApprovalModal(false)} />
              </div>

              <div className="modal-body">
                <label className="form-label fw-bold">Notes</label>

                <textarea
                  className="form-control"
                  rows="4"
                  placeholder="Enter notes..."
                  value={rhNotes}
                  onChange={(e) => setRhNotes(e.target.value)}
                />
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowRHApprovalModal(false)}>
                  Cancel
                </button>

                <button
                  className={`btn ${rhActionType === 'approve_rh' ? 'btn-success' : 'btn-danger'}`}
                  onClick={submitRHApprovalAction}
                  disabled={postLoading}
                >
                  {postLoading ? 'Submitting...' : rhActionType === 'approve_rh' ? 'Approve' : 'Reject'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showListingModal && (
        <div
          className="modal d-block"
          tabIndex="-1"
          style={{
            background: 'rgba(0,0,0,0.5)',
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Send For Listing Approval</h5>

                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShowListingModal(false);
                  }}
                />
              </div>

              <div className="modal-body">
                <label className="form-label fw-bold">Notes</label>

                <textarea
                  className="form-control"
                  rows="4"
                  placeholder="Enter Notes"
                  value={listingNote}
                  onChange={(e) => setListingNote(e.target.value)}
                />
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowListingModal(false);
                  }}
                >
                  Cancel
                </button>

                <button className="btn btn-warning" onClick={submitListingApproval} disabled={postLoading}>
                  {postLoading ? 'Submitting...' : 'Submit'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* VIEW RE-UPLOAD NOTES MODAL — Checker only */}
      {showViewNotesModal && (
        <div className="modal d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">📋 Re-Upload Notes from Maker</h5>
                <button type="button" className="btn-close" onClick={() => setShowViewNotesModal(false)} />
              </div>

              <div className="modal-body">
                <p className="mb-0" style={{ whiteSpace: 'pre-wrap' }}>
                  {viewNotesContent || 'No notes provided.'}
                </p>
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowViewNotesModal(false)}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showActivityModal && (
        <div
          className="modal show fade d-flex align-items-center justify-content-center"
          tabIndex="-1"
          style={{
            background: 'rgba(0,0,0,0.5)',
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
          }}
        >
          <div
            className="modal-dialog modal-xl modal-dialog-centered"
            style={{
              maxWidth: '1350px',
              width: '92vw',
              margin: 'auto',
            }}
          >
            <div
              className="modal-content"
              style={{
                marginLeft: '200px',
              }}
            >
              <div className="modal-header">
                <h5 className="modal-title">📋 All Repo Activities</h5>

                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShowActivityModal(false);
                    setActivityLogs([]);
                  }}
                />
              </div>

              <div className="modal-body">
                {activityLoading ? (
                  <div className="text-center py-4">Loading activities...</div>
                ) : activityLogs.length === 0 ? (
                  <div className="text-center text-muted py-4">No activity found</div>
                ) : (
                  <div className="table-responsive">
                    <table
                      className="table table-bordered align-middle"
                      style={{
                        tableLayout: 'fixed',
                      }}
                    >
                      <thead className="table-light">
                        <tr>
                          <th style={{ width: '60px' }}>#</th>

                          <th style={{ width: '55%' }}>Activity</th>

                          <th style={{ width: '18%' }}>Created By</th>

                          <th style={{ width: '22%' }}>Date & Time</th>
                        </tr>
                      </thead>

                      <tbody>
                        {activityLogs.map((log, index) => (
                          <tr
                            key={log.id}
                            style={{
                              height: 'auto',
                            }}
                          >
                            <td>{index + 1}</td>

                            <td
                              style={{
                                padding: '10px 14px',
                                lineHeight: '1.35',
                                verticalAlign: 'top',
                              }}
                            >
                              <div
                                style={{
                                  fontWeight: 600,
                                  fontSize: '15px',
                                  marginBottom: '6px',
                                  color: '#212529',
                                }}
                              >
                                {log.log_description}
                              </div>

                              {log.otherDetails &&
                                (() => {
                                  let details = {};

                                  try {
                                    details =
                                      typeof log.otherDetails === 'string'
                                        ? JSON.parse(log.otherDetails)
                                        : log.otherDetails;
                                  } catch {
                                    details = {};
                                  }

                                  return (
                                    <div className="mt-1">
                                      {Object.entries(details).map(([key, value]) => {
                                        if (
                                          key === 'court_order_file' ||
                                          key === 'lnr_document' ||
                                          key === 'section9_final_document' ||
                                          key === 'soa' ||
                                          key === 'legal_closure_document' ||
                                          key === 'loan_agreement'
                                        ) {
                                          const fileUrl = `${config.API_BASE_URL}${value}`;

                                          let label = '⬇ Download Document';

                                          if (key === 'lnr_document') label = '⬇ Download LNR';
                                          else if (key === 'section9_final_document') label = '⬇ Download Section 9';
                                          else if (key === 'soa') label = '⬇ Download SOA';
                                          else if (key === 'legal_closure_document') label = '⬇ Download Legal Closure';
                                          else if (key === 'loan_agreement') label = '⬇ Download Loan Agreement';
                                          else if (key === 'court_order_file') label = '⬇ Download Court Order';

                                          return (
                                            <div
                                              key={key}
                                              style={{
                                                marginBottom: '4px',
                                                fontSize: '13px',
                                              }}
                                            >
                                              <strong>{key.replaceAll('_', ' ').toUpperCase()}:</strong>

                                              <a
                                                href={fileUrl}
                                                target="_blank"
                                                rel="noreferrer"
                                                style={{
                                                  color: '#0d6efd',
                                                  fontSize: '12px',
                                                  fontWeight: '600',
                                                  textDecoration: 'underline',
                                                  marginLeft: '6px',
                                                }}
                                              >
                                                {label}
                                              </a>
                                            </div>
                                          );
                                        }

                                        if (value === null || value === 'null' || value === '') {
                                          return null;
                                        }

                                        return (
                                          <div
                                            key={key}
                                            style={{
                                              fontSize: '13px',
                                              color: '#6c757d',
                                              marginBottom: '2px',
                                              lineHeight: '1.4',
                                            }}
                                          >
                                            <strong>{key.replaceAll('_', ' ').toUpperCase()}:</strong> {String(value)}
                                          </div>
                                        );
                                      })}
                                    </div>
                                  );
                                })()}
                            </td>

                            <td
                              style={{
                                padding: '10px',
                                fontSize: '14px',
                                verticalAlign: 'middle',
                              }}
                            >
                              {log.created_by_name || 'User'}
                            </td>

                            <td
                              style={{
                                padding: '10px',
                                fontSize: '14px',
                                whiteSpace: 'nowrap',
                                verticalAlign: 'middle',
                              }}
                            >
                              {new Date(log.created_on).toLocaleString('en-IN', {
                                day: '2-digit',
                                month: 'short',
                                year: 'numeric',

                                hour: '2-digit',
                                minute: '2-digit',
                              })}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {showRepoDetailsModal && (
        <div className="modal d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-scrollable" style={{ maxWidth: '1000px' }}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Complete Repo Details</h5>

                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShowRepoDetailsModal(false);
                    setRepoDetails(null);
                  }}
                />
              </div>

              <div className="modal-body">
                {repoDetailsLoading ? (
                  <div className="text-center py-4">Loading details...</div>
                ) : repoDetails ? (
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <strong>Agreement No:</strong>
                      <br />
                      {repoDetails?.agreement_no || '-'}
                    </div>

                    <div className="col-md-6 mb-3">
                      <strong>Customer Name:</strong>
                      <br />
                      {repoDetails?.customer_name || '-'}
                    </div>

                    <div className="col-md-6 mb-3">
                      <strong>Mobile:</strong>
                      <br />
                      {repoDetails?.mobile || '-'}
                    </div>

                    <div className="col-md-6 mb-3">
                      <strong>Make:</strong>
                      <br />
                      {repoDetails?.make || '-'}
                    </div>

                    <div className="col-md-6 mb-3">
                      <strong>Model:</strong>
                      <br />
                      {repoDetails?.model || '-'}
                    </div>

                    <div className="col-md-6 mb-3">
                      <strong>Year:</strong>
                      <br />
                      {repoDetails?.vehicle_year || '-'}
                    </div>

                    <div className="col-md-6 mb-3">
                      <strong>Registration Number:</strong>
                      <br />
                      {repoDetails?.registration_number || '-'}
                    </div>

                    <div className="col-md-6 mb-3">
                      <strong>Mileage:</strong>
                      <br />
                      {repoDetails?.mileage || '-'}
                    </div>

                    <div className="col-md-6 mb-3">
                      <strong>Repo Reason:</strong>
                      <br />
                      {repoDetails?.repo_reason || '-'}
                    </div>

                    {/* <div className="col-md-12 mt-3">
                <button
                  className="btn btn-primary"
                  onClick={() => {

                    navigate(
                      `/dashboard/create-vehicle-repo/${btoa(String(repoDetails?.agreement_no))}`
                    );

                  }}
                >
                  Edit Repo
                </button>
              </div> */}
                  </div>
                ) : (
                  <div className="text-center text-muted py-4">No details found</div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {showInventoryModal && (
        <div className="modal d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-scrollable" style={{ maxWidth: '1000px' }}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Inventory Details</h5>

                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShowInventoryModal(false);
                    setInventoryDetails(null);
                  }}
                />
              </div>

              <div className="modal-body">
                {inventoryLoading ? (
                  <div className="text-center py-4">Loading inventory...</div>
                ) : inventoryDetails ? (
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <strong>Agreement No:</strong>
                      <br />
                      {inventoryDetails?.agreement_no || '-'}
                    </div>

                    <div className="col-md-6 mb-3">
                      <strong>Customer Name:</strong>
                      <br />
                      {inventoryDetails?.customer_name || '-'}
                    </div>

                    <div className="col-md-6 mb-3">
                      <strong>Mobile:</strong>
                      <br />
                      {inventoryDetails?.mobile || '-'}
                    </div>

                    <div className="col-md-6 mb-3">
                      <strong>Make:</strong>
                      <br />
                      {inventoryDetails?.make || '-'}
                    </div>

                    <div className="col-md-6 mb-3">
                      <strong>Model:</strong>
                      <br />
                      {inventoryDetails?.model || '-'}
                    </div>

                    <div className="col-md-6 mb-3">
                      <strong>Registration Number:</strong>
                      <br />
                      {inventoryDetails?.registration_number || '-'}
                    </div>

                    <div className="col-md-6 mb-3">
                      <strong>Vehicle Year:</strong>
                      <br />
                      {inventoryDetails?.vehicle_year || '-'}
                    </div>

                    <div className="col-md-6 mb-3">
                      <strong>Mileage:</strong>
                      <br />
                      {inventoryDetails?.mileage || '-'}
                    </div>

                    <div className="col-md-12 mt-3">
                      {/* <button
                  className="btn btn-primary"
                  onClick={() => {

                    navigate(
                      `/dashboard/final-submission/${btoa(String(inventoryDetails?.repo_id))}`
                    );

                  }}
                >
                  Go To Inventory Page
                </button> */}
                    </div>
                  </div>
                ) : (
                  <div className="text-center text-muted py-4">No inventory found</div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {showFlowModal &&
        selectedFlowItem &&
        repoFlowData &&
        (() => {
          const allSteps = repoFlowData.steps || [
            'Pending',
            'Approved',
            'Pending for Court Order Review',
            'Court Order Approved',
            'Repo Initiated',
            'Repo Checklist Submitted',
            'Inspection Scheduled',
            'Inventory Created',
            'Yard Placement Pending',
            'Vehicle Yarded',
            'Ready For Listing Approval',
            'Listing Approved',
            'Live For Auction',
            'Auction Completed',
            'Sold',
          ];

          // ===== DYNAMIC STEP MAP =====
          const logStepMap = {
            'Legal action created with status Pending': 'Pending',

            'Legal action Approved': 'Approved',

            'Court order uploaded and sent for review': 'Pending for Court Order Review',

            'Court Order Approved': 'Court Order Approved',

            'Repo process initiated successfully': 'Repo Initiated',

            'Repo checklist submitted successfully': 'Repo Checklist Submitted',

            'Inspection scheduled successfully': 'Inspection Scheduled',

            'Final inventory created successfully': 'Inventory Created',

            'Yard placement updated successfully': 'Yard Placement Pending',

            'Vehicle yarded successfully': 'Vehicle Yarded',

            'Ready for listing approval': 'Ready For Listing Approval',

            'Listing approved successfully': 'Listing Approved',

            'Vehicle live for auction': 'Live For Auction',

            'Auction completed successfully': 'Auction Completed',

            'Vehicle sold successfully': 'Sold',
          };

          // ===== FIND CURRENT STEP FROM ACTIVITY LOGS =====

          const currentStep = repoFlowData.current_step || 'Pending';

          const currentIndex = repoFlowData.current_index || 0;

          const activeIndex = repoFlowData.active_index || 1;

          return (
            <div
              className="modal show fade d-flex align-items-center justify-content-center"
              style={{
                background: 'rgba(0,0,0,0.45)',
                position: 'fixed',
                inset: 0,
                zIndex: 999999,
              }}
            >
              <div
                className="modal-dialog modal-dialog-centered"
                style={{
                  maxWidth: '680px',
                  width: '95%',
                }}
              >
                <div
                  className="modal-content"
                  style={{
                    borderRadius: '22px',
                    overflow: 'hidden',
                    border: 'none',
                    boxShadow: '0 20px 60px rgba(0,0,0,0.18)',
                  }}
                >
                  {/* HEADER */}

                  <div
                    className="modal-header"
                    style={{
                      background: 'linear-gradient(135deg,#0f172a,#1e293b)',
                      color: '#fff',
                      padding: '20px 28px',
                      border: 'none',
                    }}
                  >
                    <div>
                      <h4
                        style={{
                          margin: 0,
                          fontWeight: '700',
                        }}
                      >
                        Repo Progress Flow
                      </h4>

                      <div
                        style={{
                          opacity: 0.8,
                          fontSize: '13px',
                          marginTop: '4px',
                        }}
                      >
                        Agreement No : {selectedFlowItem.AgreementNo}
                      </div>
                    </div>

                    <button
                      type="button"
                      className="btn-close btn-close-white"
                      onClick={() => setShowFlowModal(false)}
                    />
                  </div>

                  {/* BODY */}

                  <div
                    className="modal-body"
                    style={{
                      padding: '30px 26px',
                      background: '#f8fafc',
                      maxHeight: '70vh',
                      overflowY: 'auto',
                    }}
                  >
                    {allSteps.map((step, index) => {
                      const completed = index <= currentIndex;

                      const active = index === activeIndex;

                      return (
                        <div
                          key={step}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: '28px',
                            position: 'relative',
                          }}
                        >
                          {/* LINE */}

                          {index !== allSteps.length - 1 && (
                            <div
                              style={{
                                position: 'absolute',
                                left: '20px',
                                top: '42px',
                                width: '4px',
                                height: '60px',
                                background: completed ? '#16a34a' : '#d4d4d8',
                                borderRadius: '20px',
                              }}
                            />
                          )}

                          {/* CIRCLE */}

                          <div
                            style={{
                              minWidth: '42px',
                              height: '42px',
                              borderRadius: '50%',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontWeight: '700',
                              color: '#fff',
                              fontSize: '15px',
                              zIndex: 2,
                              background: completed ? '#16a34a' : active ? '#f59e0b' : '#cbd5e1',
                              animation: active ? 'pulse 1.2s infinite' : 'none',
                              boxShadow: completed
                                ? '0 0 15px rgba(22,163,74,0.35)'
                                : active
                                ? '0 0 18px rgba(245,158,11,0.45)'
                                : 'none',
                            }}
                          >
                            {completed ? '✓' : index + 1}
                          </div>

                          {/* CONTENT */}

                          <div style={{ marginLeft: '18px', flex: 1 }}>
                            <div
                              style={{
                                fontSize: '16px',
                                fontWeight: '700',
                                color: completed || active ? '#0f172a' : '#64748b',
                              }}
                            >
                              {step}
                            </div>

                            <div
                              style={{
                                fontSize: '13px',
                                marginTop: '3px',
                                color: '#64748b',
                              }}
                            >
                              {completed ? 'Completed Successfully' : active ? 'Current Active Step' : 'Waiting'}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

              <style>
                {`
          @keyframes pulse {

            0% {
              transform: scale(1);
              opacity: 1;
            }

            50% {
              transform: scale(1.08);
              opacity: 0.7;
            }

            100% {
              transform: scale(1);
              opacity: 1;
            }

          }
        `}
              </style>
            </div>
          );
        })()}

      {/* REPAIR COST MODAL */}
      {showRepairCostModal && (
        <div className="modal d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)', zIndex: 9999 }}>
          <div className="modal-dialog modal-dialog-centered modal-lg" style={{ maxWidth: '700px' }}>
            <div className="modal-content">
              <div className="modal-header" style={{ background: '#6f42c1', color: '#fff' }}>
                <h5 className="modal-title">🔧 Repair / Refurbishment Cost Details</h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => {
                    setShowRepairCostModal(false);
                    setRepairCostData(null);
                  }}
                />
              </div>

              <div className="modal-body">
                {repairCostLoading ? (
                  <div className="text-center py-4">
                    <div className="spinner-border text-primary" />
                    <p className="mt-2">Loading...</p>
                  </div>
                ) : repairCostData ? (
                  <>
                    {/* Vehicle Info */}
                    <div className="alert alert-secondary py-2 mb-3">
                      <strong>{repairCostData.agreement_no}</strong> — {repairCostData.make} {repairCostData.model} |{' '}
                      Reg: {repairCostData.registration_number || 'N/A'}
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="text-muted" style={{ fontSize: '12px' }}>
                          Vendor Name
                        </label>
                        <div className="fw-bold">{repairCostData.vendor_name || '-'}</div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <label className="text-muted" style={{ fontSize: '12px' }}>
                          Refurbishment Status
                        </label>
                        <div>
                          <span className="badge bg-warning text-dark">
                            {repairCostData.refurbishment_status || '-'}
                          </span>
                        </div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <label className="text-muted" style={{ fontSize: '12px' }}>
                          Estimated Repair Cost
                        </label>
                        <div className="fw-bold text-primary" style={{ fontSize: '16px' }}>
                          ₹ {Number(repairCostData.estimated_cost || 0).toLocaleString('en-IN')}
                        </div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <label className="text-muted" style={{ fontSize: '12px' }}>
                          Challan
                        </label>
                        <div>
                          {repairCostData.challan_status === 'Yes' ? (
                            <>
                              <span className="badge bg-danger me-1">Yes</span>₹{' '}
                              {Number(repairCostData.challan_amount || 0).toLocaleString('en-IN')}
                              {repairCostData.challan_number && (
                                <small className="text-muted d-block">
                                  No: {repairCostData.challan_number}
                                  {repairCostData.challan_type ? ` | Type: ${repairCostData.challan_type}` : ''}
                                </small>
                              )}
                            </>
                          ) : (
                            <span className="badge bg-success">No</span>
                          )}
                        </div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <label className="text-muted" style={{ fontSize: '12px' }}>
                          RTO Charges
                        </label>
                        <div>
                          {repairCostData.rto_charges === 'Yes' ? (
                            <>
                              <span className="badge bg-warning text-dark me-1">Yes</span>
                              <small>By: {repairCostData.rto_charges_by || '-'}</small>
                            </>
                          ) : (
                            <span className="badge bg-success">No</span>
                          )}
                        </div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <label className="text-muted" style={{ fontSize: '12px' }}>
                          Other Expenses
                        </label>
                        <div>
                          {repairCostData.other_expenses === 'Yes' ? (
                            <>
                              <span className="badge bg-secondary me-1">Yes</span>₹{' '}
                              {Number(repairCostData.other_expenses_amount || 0).toLocaleString('en-IN')}
                            </>
                          ) : (
                            <span className="badge bg-success">No</span>
                          )}
                        </div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <label className="text-muted" style={{ fontSize: '12px' }}>
                          Insurance Validity
                        </label>
                        <div>
                          <span
                            className={`badge ${
                              repairCostData.insurance_validity === 'Yes' ? 'bg-success' : 'bg-danger'
                            }`}
                          >
                            {repairCostData.insurance_validity || '-'}
                          </span>
                        </div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <label className="text-muted" style={{ fontSize: '12px' }}>
                          Fitness Validity
                        </label>
                        <div>
                          <span
                            className={`badge ${
                              repairCostData.fitness_validity === 'Yes' ? 'bg-success' : 'bg-danger'
                            }`}
                          >
                            {repairCostData.fitness_validity || '-'}
                          </span>
                        </div>
                      </div>

                      {repairCostData.refurbishment_notes && (
                        <div className="col-12 mb-3">
                          <label className="text-muted" style={{ fontSize: '12px' }}>
                            Notes
                          </label>
                          <div className="border rounded p-2" style={{ background: '#f8f9fa', fontSize: '13px' }}>
                            {repairCostData.refurbishment_notes}
                          </div>
                        </div>
                      )}

                      {/* BILL IMAGE — View + Download */}
                      {repairCostData.bill_image && (
                        <div className="col-12 mb-3">
                          <label className="text-muted d-block" style={{ fontSize: '12px' }}>
                            Bill / Receipt
                          </label>
                          <div className="d-flex gap-2">
                            <a
                              href={`${config.API_BASE_URL}${repairCostData.bill_image}`}
                              download
                              target="_blank"
                              rel="noreferrer"
                              className="btn btn-sm"
                              style={{
                                padding: '5px 12px',
                                fontSize: '12px',
                                fontWeight: 600,
                                backgroundColor: '#198754',
                                color: '#fff',
                                borderRadius: '6px',
                                textDecoration: 'none',
                              }}
                            >
                              ⬇ Download Raw Bill
                            </a>
                          </div>
                        </div>
                      )}

                      {repairCostData.additional_information && (
                        <div className="col-12 mb-3">
                          <label className="text-muted" style={{ fontSize: '12px' }}>
                            Additional Info
                          </label>
                          <div className="border rounded p-2" style={{ background: '#f8f9fa', fontSize: '13px' }}>
                            {repairCostData.additional_information}
                          </div>
                        </div>
                      )}
                    </div>

                    {/* TOTAL COST SUMMARY */}
                    <div className="mt-2 p-3 rounded" style={{ background: '#f0ebff', border: '1.5px solid #6f42c1' }}>
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <div style={{ fontSize: '12px', color: '#6f42c1' }}>Estimated Repair</div>
                          <div className="fw-bold">
                            ₹ {Number(repairCostData.estimated_cost || 0).toLocaleString('en-IN')}
                          </div>
                        </div>
                        {repairCostData.challan_status === 'Yes' && (
                          <div>
                            <div style={{ fontSize: '12px', color: '#6f42c1' }}>Challan</div>
                            <div className="fw-bold">
                              ₹ {Number(repairCostData.challan_amount || 0).toLocaleString('en-IN')}
                            </div>
                          </div>
                        )}
                        {repairCostData.other_expenses === 'Yes' && (
                          <div>
                            <div style={{ fontSize: '12px', color: '#6f42c1' }}>Other Expenses</div>
                            <div className="fw-bold">
                              ₹ {Number(repairCostData.other_expenses_amount || 0).toLocaleString('en-IN')}
                            </div>
                          </div>
                        )}
                        <div style={{ borderLeft: '2px solid #6f42c1', paddingLeft: '16px' }}>
                          <div style={{ fontSize: '12px', color: '#6f42c1', fontWeight: '600' }}>TOTAL COST</div>
                          <div style={{ fontSize: '20px', fontWeight: '700', color: '#6f42c1' }}>
                            ₹ {Number(repairCostData.total_cost || 0).toLocaleString('en-IN')}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="text-center text-muted py-4">No data found</div>
                )}
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowRepairCostModal(false);
                    setRepairCostData(null);
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showDealLockModal && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(15,23,42,.55)',
            backdropFilter: 'blur(5px)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 999999,
          }}
        >
          <div
            style={{
              width: '600px',
              background: '#fff',
              borderRadius: '18px',
              padding: '28px',
              boxShadow: '0 25px 60px rgba(0,0,0,.25)',
              maxHeight: '85vh',
              overflowY: 'auto',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '25px',
                borderBottom: '1px solid #ececec',
                paddingBottom: '15px',
              }}
            >
              <div>
                <h4
                  style={{
                    margin: 0,
                    fontWeight: '700',
                    color: '#111827',
                  }}
                >
                  🔒 Deal Lock Details
                </h4>

                <div
                  style={{
                    fontSize: '13px',
                    color: '#6b7280',
                    marginTop: '5px',
                  }}
                >
                  Enter Deal Lock Information
                </div>
              </div>

              <button
                onClick={() => setShowDealLockModal(false)}
                style={{
                  border: 'none',
                  background: '#f3f4f6',
                  width: '34px',
                  height: '34px',
                  borderRadius: '50%',
                  cursor: 'pointer',
                  fontSize: '18px',
                  fontWeight: '700',
                }}
              >
                ×
              </button>
            </div>

            {/* Deal Amount */}

            <div className="mb-3">
              <label
                style={{
                  fontWeight: '600',
                  fontSize: '13px',
                  marginBottom: '6px',
                  display: 'block',
                }}
              >
                Deal Amount
              </label>

              <input
                type="number"
                className="form-control"
                placeholder="Enter Deal Amount"
                value={dealAmount}
                onChange={(e) => setDealAmount(e.target.value)}
              />
            </div>

            {/* Token Received */}

            <div className="mb-3">
              <label
                style={{
                  fontWeight: '600',
                  fontSize: '13px',
                  marginBottom: '6px',
                  display: 'block',
                }}
              >
                Token Received
              </label>

              <select className="form-control" value={tokenReceived} onChange={(e) => setTokenReceived(e.target.value)}>
                <option value="">Select</option>

                <option value="Yes">Yes</option>

                <option value="No">No</option>
              </select>
            </div>

            {/* SHOW ONLY IF YES */}

            {tokenReceived === 'Yes' && (
              <>
                <div className="mb-3">
                  <label
                    style={{
                      fontWeight: '600',
                      fontSize: '13px',
                      marginBottom: '6px',
                      display: 'block',
                    }}
                  >
                    Token Amount
                  </label>

                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter Token Amount"
                    value={tokenAmount}
                    onChange={(e) => setTokenAmount(e.target.value)}
                  />
                </div>

                <div className="mb-3">
                  <label
                    style={{
                      fontWeight: '600',
                      fontSize: '13px',
                      marginBottom: '6px',
                      display: 'block',
                    }}
                  >
                    Upload Amount Screenshot
                  </label>

                  <input type="file" className="form-control" onChange={(e) => setDealScreenshot(e.target.files[0])} />
                </div>
              </>
            )}

            {/* Remarks */}

            <div className="mb-3">
              <label
                style={{
                  fontWeight: '600',
                  fontSize: '13px',
                  marginBottom: '6px',
                  display: 'block',
                }}
              >
                Remarks
              </label>

              <textarea
                rows="4"
                className="form-control"
                placeholder="Enter remarks"
                value={dealLockNotes}
                onChange={(e) => setDealLockNotes(e.target.value)}
              />
            </div>

            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '12px',
                marginTop: '30px',
              }}
            >
              <button
                onClick={() => setShowDealLockModal(false)}
                style={{
                  border: 'none',
                  background: '#f3f4f6',
                  padding: '10px 18px',
                  borderRadius: '8px',
                  fontWeight: '600',
                }}
              >
                Cancel
              </button>

              <button
                onClick={submitDealLock}
                style={{
                  border: 'none',
                  background: '#059669',
                  color: '#fff',
                  padding: '10px 18px',
                  borderRadius: '8px',
                  fontWeight: '600',
                }}
              >
                🔒 Save Deal Lock
              </button>
            </div>
          </div>
        </div>
      )}

      {showListingAmountModal && (
        <div className="modal d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Send Listing Amount For Approval</h5>

                <button type="button" className="btn-close" onClick={() => setShowListingAmountModal(false)} />
              </div>

              <div className="modal-body">
                <label className="form-label fw-bold">Listing Amount 1</label>
                <input
                  type="number"
                  className="form-control mb-3"
                  placeholder="Enter listing amount 1"
                  value={listingAmount1}
                  onChange={(e) => setListingAmount1(e.target.value)}
                />

                <label className="form-label fw-bold">Listing Amount 2</label>
                <input
                  type="number"
                  className="form-control mb-3"
                  placeholder="Enter listing amount 2"
                  value={listingAmount2}
                  onChange={(e) => setListingAmount2(e.target.value)}
                />

                <label className="form-label fw-bold">Listing Amount 3</label>
                <input
                  type="number"
                  className="form-control mb-3"
                  placeholder="Enter listing amount 3"
                  value={listingAmount3}
                  onChange={(e) => setListingAmount3(e.target.value)}
                />

                <label className="form-label fw-bold">Notes</label>

                <textarea
                  className="form-control"
                  rows="4"
                  placeholder="Enter notes"
                  value={listingAmountNote}
                  onChange={(e) => setListingAmountNote(e.target.value)}
                />
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowListingAmountModal(false)}>
                  Cancel
                </button>

                <button
                  className="btn btn-success"
                  onClick={submitListingAmountApproval}
                  disabled={postLoading}
                  style={{ opacity: postLoading ? 0.7 : 1 }}
                >
                  {postLoading ? 'Submitting...' : 'Send For Approval'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showListingAmountApprovalModal && (
        <div className="modal d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {listingAmountApprovalAction === 'approve' ? 'Approve Listing Amount' : 'Reject Listing Amount'}
                </h5>

                <button type="button" className="btn-close" onClick={() => setShowListingAmountApprovalModal(false)} />
              </div>

              <div className="modal-body">
                {listingAmountApprovalAction === 'approve' && (
                  <div className="mb-3">
                    <label className="form-label fw-bold">Select Listing Amount</label>

                    {listingAmountOptionsLoading ? (
                      <div className="text-muted" style={{ fontSize: '13px' }}>
                        Loading amounts...
                      </div>
                    ) : listingAmountOptions ? (
                      <div className="d-flex flex-column gap-2">
                        {[
                          { key: 'listing_amount_1', label: 'Listing Amount 1' },
                          { key: 'listing_amount_2', label: 'Listing Amount 2' },
                          { key: 'listing_amount_3', label: 'Listing Amount 3' },
                        ].map((opt) => (
                          <label
                            key={opt.key}
                            className="d-flex align-items-center gap-2 border rounded p-2"
                            style={{
                              cursor: 'pointer',
                              background:
                                selectedListingApprovedAmount === String(listingAmountOptions[opt.key])
                                  ? '#e8f5ee'
                                  : '#fff',
                              borderColor:
                                selectedListingApprovedAmount === String(listingAmountOptions[opt.key])
                                  ? '#198754'
                                  : '#dee2e6',
                            }}
                          >
                            <input
                              type="radio"
                              name="listingApprovedAmount"
                              value={listingAmountOptions[opt.key]}
                              checked={selectedListingApprovedAmount === String(listingAmountOptions[opt.key])}
                              onChange={(e) => setSelectedListingApprovedAmount(e.target.value)}
                            />
                            <span>
                              {opt.label} —{' '}
                              <strong>₹ {Number(listingAmountOptions[opt.key] || 0).toLocaleString('en-IN')}</strong>
                            </span>
                          </label>
                        ))}
                      </div>
                    ) : (
                      <div className="text-muted" style={{ fontSize: '13px' }}>
                        No amounts found
                      </div>
                    )}
                  </div>
                )}

                <label className="form-label fw-bold">Notes</label>

                <textarea
                  className="form-control"
                  rows="4"
                  placeholder="Please enter the selective listing amount and add your approval note."
                  value={listingAmountApprovalNote}
                  onChange={(e) => setListingAmountApprovalNote(e.target.value)}
                />
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowListingAmountApprovalModal(false)}>
                  Cancel
                </button>

                <button
                  className={`btn ${listingAmountApprovalAction === 'approve' ? 'btn-success' : 'btn-danger'}`}
                  onClick={submitListingAmountApprovalAction}
                  disabled={postLoading}
                  style={{ opacity: postLoading ? 0.7 : 1 }}
                >
                  {postLoading ? 'Submitting...' : listingAmountApprovalAction === 'approve' ? 'Approve' : 'Reject'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showListingAmountDetailModal && (
        <div className="modal d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header" style={{ background: '#6f42c1', color: '#fff' }}>
                <h5 className="modal-title">💰 Listing Amount Details</h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setShowListingAmountDetailModal(false)}
                />
              </div>

              <div className="modal-body">
                {listingAmountDetailLoading ? (
                  <div className="text-center py-4">Loading...</div>
                ) : listingAmountDetailData ? (
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="text-muted" style={{ fontSize: '12px' }}>
                        Agreement No
                      </label>
                      <div className="fw-bold">{listingAmountDetailData.agreement_no || '-'}</div>
                    </div>

                    <div className="col-md-4 mb-3">
                      <label className="text-muted" style={{ fontSize: '12px' }}>
                        Listing Amount 1
                      </label>
                      <div className="fw-bold text-primary" style={{ fontSize: '16px' }}>
                        ₹ {Number(listingAmountDetailData.listing_amount_1 || 0).toLocaleString('en-IN')}
                      </div>
                    </div>

                    <div className="col-md-4 mb-3">
                      <label className="text-muted" style={{ fontSize: '12px' }}>
                        Listing Amount 2
                      </label>
                      <div className="fw-bold text-primary" style={{ fontSize: '16px' }}>
                        ₹ {Number(listingAmountDetailData.listing_amount_2 || 0).toLocaleString('en-IN')}
                      </div>
                    </div>

                    <div className="col-md-4 mb-3">
                      <label className="text-muted" style={{ fontSize: '12px' }}>
                        Listing Amount 3
                      </label>
                      <div className="fw-bold text-primary" style={{ fontSize: '16px' }}>
                        ₹ {Number(listingAmountDetailData.listing_amount_3 || 0).toLocaleString('en-IN')}
                      </div>
                    </div>

                    <div className="col-md-6 mb-3">
                      <label className="text-muted" style={{ fontSize: '12px' }}>
                        Status
                      </label>
                      <div>
                        <span className="badge bg-warning text-dark">{listingAmountDetailData.status || '-'}</span>
                      </div>
                    </div>

                    <div className="col-md-6 mb-3">
                      <label className="text-muted" style={{ fontSize: '12px' }}>
                        Submitted By
                      </label>
                      <div>{listingAmountDetailData.created_by_name || '-'}</div>
                    </div>

                    <div className="col-12 mb-2">
                      <label className="text-muted" style={{ fontSize: '12px' }}>
                        Notes
                      </label>
                      <div className="border rounded p-2" style={{ background: '#f8f9fa', fontSize: '13px' }}>
                        {listingAmountDetailData.notes || '-'}
                      </div>
                    </div>

                    {listingAmountDetailData.action_notes && (
                      <div className="col-12 mb-2">
                        <label className="text-muted" style={{ fontSize: '12px' }}>
                          Action Remarks
                        </label>
                        <div className="border rounded p-2" style={{ background: '#f8f9fa', fontSize: '13px' }}>
                          {listingAmountDetailData.action_notes}
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="text-center text-muted py-4">No data found</div>
                )}
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowListingAmountDetailModal(false);
                    setListingAmountDetailData(null);
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showFinalRepairModal && (
        <div className="modal d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)', zIndex: 9999 }}>
          <div className="modal-dialog modal-dialog-centered modal-lg" style={{ maxWidth: '650px' }}>
            <div className="modal-content">
              <div className="modal-header" style={{ background: '#0d6efd', color: '#fff' }}>
                <h5 className="modal-title">🛠 Final Repair Submission</h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setShowFinalRepairModal(false)}
                />
              </div>

              <div className="modal-body">
                <label className="form-label fw-bold">Repaired Vehicle Images</label>
                <input
                  type="file"
                  multiple
                  accept=".jpg,.jpeg,.png"
                  className="form-control mb-2"
                  onChange={(e) => setFinalRepairImages(Array.from(e.target.files))}
                />
                {finalRepairImages.length > 0 && (
                  <small className="text-muted d-block mb-3">{finalRepairImages.length} image(s) selected</small>
                )}

                <label className="form-label fw-bold">Upload Bill</label>
                <input
                  type="file"
                  accept=".jpg,.jpeg,.png,.pdf"
                  className="form-control mb-3"
                  onChange={(e) => setFinalRepairBill(e.target.files[0])}
                />

                <hr />

                <h6 className="fw-bold mb-2">Vendor Bank Details</h6>

                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Beneficiary Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter beneficiary name"
                      value={beneficiaryName}
                      onChange={(e) => setBeneficiaryName(e.target.value)}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Bank Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter bank name"
                      value={bankName}
                      onChange={(e) => setBankName(e.target.value)}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Account No</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter account number"
                      value={accountNo}
                      onChange={(e) => setAccountNo(e.target.value)}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">IFSC Code</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter IFSC code"
                      value={ifscCode}
                      onChange={(e) => setIfscCode(e.target.value.toUpperCase())}
                    />
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowFinalRepairModal(false)}>
                  Cancel
                </button>

                <button
                  className="btn btn-primary"
                  onClick={submitFinalRepairSubmission}
                  disabled={postLoading}
                  style={{ opacity: postLoading ? 0.7 : 1 }}
                >
                  {postLoading ? 'Submitting...' : 'Send To Credit Team'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* VIEW FINAL REPAIR SUBMISSION */}
      {showFinalRepairViewModal && (
        <div className="modal d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)', zIndex: 9999 }}>
          <div className="modal-dialog modal-dialog-centered modal-lg" style={{ maxWidth: '750px' }}>
            <div className="modal-content">
              <div className="modal-header" style={{ background: '#0d6efd', color: '#fff' }}>
                <h5 className="modal-title">📄 Final Repair Submission Details</h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => {
                    setShowFinalRepairViewModal(false);
                    setFinalRepairViewData(null);
                  }}
                />
              </div>

              <div className="modal-body">
                {finalRepairViewLoading ? (
                  <div className="text-center py-4">Loading...</div>
                ) : finalRepairViewData ? (
                  <>
                    <div className="alert alert-secondary py-2 mb-3">
                      <strong>{finalRepairViewData.agreement_no}</strong>{' '}
                      <span className="badge bg-warning text-dark ms-2">{finalRepairViewData.status}</span>
                    </div>

                    <label className="text-muted d-block mb-1" style={{ fontSize: '12px' }}>
                      Repaired Vehicle Images
                    </label>
                    <div className="d-flex flex-wrap gap-2 mb-3">
                      {finalRepairViewData.repair_images.map((img, idx) => (
                        <a key={idx} href={`${config.API_BASE_URL}${img}`} target="_blank" rel="noreferrer">
                          <img
                            src={`${config.API_BASE_URL}${img}`}
                            alt={`repair-${idx}`}
                            style={{
                              width: '90px',
                              height: '90px',
                              objectFit: 'cover',
                              borderRadius: '6px',
                              border: '1px solid #ddd',
                            }}
                          />
                        </a>
                      ))}
                    </div>

                    <label className="text-muted d-block mb-1" style={{ fontSize: '12px' }}>
                      Bill
                    </label>
                    <a
                      href={`${config.API_BASE_URL}${finalRepairViewData.bill_image}`}
                      download
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-sm mb-3"
                      style={{ backgroundColor: '#198754', color: '#fff', fontSize: '12px', fontWeight: 600 }}
                    >
                      ⬇ Download Bill
                    </a>

                    <hr />

                    <h6 className="fw-bold mb-2">Vendor Bank Details</h6>
                    <div className="row">
                      <div className="col-md-6 mb-2">
                        <label className="text-muted" style={{ fontSize: '12px' }}>
                          Beneficiary Name
                        </label>
                        <div className="fw-bold">{finalRepairViewData.beneficiary_name}</div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <label className="text-muted" style={{ fontSize: '12px' }}>
                          Bank Name
                        </label>
                        <div className="fw-bold">{finalRepairViewData.bank_name}</div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <label className="text-muted" style={{ fontSize: '12px' }}>
                          Account No
                        </label>
                        <div className="fw-bold">{finalRepairViewData.account_no}</div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <label className="text-muted" style={{ fontSize: '12px' }}>
                          IFSC Code
                        </label>
                        <div className="fw-bold">{finalRepairViewData.ifsc_code}</div>
                      </div>
                    </div>

                    {finalRepairViewData.credit_notes && (
                      <div className="mt-3">
                        <label className="text-muted d-block" style={{ fontSize: '12px' }}>
                          Credit Team Remarks
                        </label>
                        <div className="border rounded p-2" style={{ background: '#f8f9fa', fontSize: '13px' }}>
                          {finalRepairViewData.credit_notes} —{' '}
                          <em>{finalRepairViewData.credit_action_by_name || '-'}</em>
                        </div>
                      </div>
                    )}

                    {finalRepairViewData.rh_notes && (
                      <div className="mt-2">
                        <label className="text-muted d-block" style={{ fontSize: '12px' }}>
                          BH Remarks
                        </label>
                        <div className="border rounded p-2" style={{ background: '#f8f9fa', fontSize: '13px' }}>
                          {finalRepairViewData.rh_notes} — <em>{finalRepairViewData.rh_action_by_name || '-'}</em>
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <div className="text-center text-muted py-4">No data found</div>
                )}
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowFinalRepairViewModal(false);
                    setFinalRepairViewData(null);
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* CREDIT TEAM ACCEPT/REJECT MODAL */}
      {showCreditFinalRepairActionModal && (
        <div className="modal d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {creditFinalRepairAction === 'approve' ? 'Send Final Repair To BH' : 'Reject Final Repair'}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowCreditFinalRepairActionModal(false)}
                />
              </div>

              <div className="modal-body">
                <label className="form-label fw-bold">Notes </label>
                <textarea
                  className="form-control"
                  rows="4"
                  placeholder="Enter notes..."
                  value={creditFinalRepairNote}
                  onChange={(e) => setCreditFinalRepairNote(e.target.value)}
                />
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowCreditFinalRepairActionModal(false)}>
                  Cancel
                </button>
                <button
                  className={`btn ${creditFinalRepairAction === 'approve' ? 'btn-success' : 'btn-danger'}`}
                  onClick={submitCreditFinalRepairAction}
                  disabled={postLoading}
                >
                  {postLoading ? 'Submitting...' : creditFinalRepairAction === 'approve' ? 'Send To BH' : 'Reject'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* RH ACCEPT/REJECT MODAL */}
      {showRHFinalRepairActionModal && (
        <div className="modal d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {rhFinalRepairAction === 'approve' ? 'Approve Final Repair (RH)' : 'Reject Final Repair (RH)'}
                </h5>
                <button type="button" className="btn-close" onClick={() => setShowRHFinalRepairActionModal(false)} />
              </div>

              <div className="modal-body">
                <label className="form-label fw-bold">Notes </label>
                <textarea
                  className="form-control"
                  rows="4"
                  placeholder="Enter notes..."
                  value={rhFinalRepairNote}
                  onChange={(e) => setRhFinalRepairNote(e.target.value)}
                />
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowRHFinalRepairActionModal(false)}>
                  Cancel
                </button>
                <button
                  className={`btn ${rhFinalRepairAction === 'approve' ? 'btn-success' : 'btn-danger'}`}
                  onClick={submitRHFinalRepairAction}
                  disabled={postLoading}
                >
                  {postLoading ? 'Submitting...' : rhFinalRepairAction === 'approve' ? 'Approve' : 'Reject'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ADMIN -> TRANSFER TO FINANCE TEAM MODAL */}
      {showFinanceTransferModal && (
        <div className="modal d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Transfer to Finance Team</h5>
                <button type="button" className="btn-close" onClick={() => setShowFinanceTransferModal(false)} />
              </div>
              <div className="modal-body">
                <label className="form-label fw-bold">Notes </label>
                <textarea
                  className="form-control"
                  rows="4"
                  placeholder="Enter notes..."
                  value={financeTransferNote}
                  onChange={(e) => setFinanceTransferNote(e.target.value)}
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowFinanceTransferModal(false)}>
                  Cancel
                </button>
                <button className="btn btn-success" onClick={submitFinanceTransfer} disabled={postLoading}>
                  {postLoading ? 'Submitting...' : 'Transfer to Finance Team'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* FINANCE TEAM -> ACCEPT MODAL */}
      {showFinanceAcceptModal && (
        <div className="modal d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Accept — Finance Team</h5>
                <button type="button" className="btn-close" onClick={() => setShowFinanceAcceptModal(false)} />
              </div>
              <div className="modal-body">
                <label className="form-label fw-bold">Notes </label>
                <textarea
                  className="form-control"
                  rows="4"
                  placeholder="Enter notes..."
                  value={financeAcceptNote}
                  onChange={(e) => setFinanceAcceptNote(e.target.value)}
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowFinanceAcceptModal(false)}>
                  Cancel
                </button>
                <button className="btn btn-success" onClick={submitFinanceAccept} disabled={postLoading}>
                  {postLoading ? 'Submitting...' : 'Accept'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* FINANCE TEAM -> UPLOAD PROOF MODAL */}
      {showFinanceUploadModal && (
        <div className="modal d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Upload Payment Proof</h5>
                <button type="button" className="btn-close" onClick={() => setShowFinanceUploadModal(false)} />
              </div>
              <div className="modal-body">
                <label className="form-label fw-bold">Upload File </label>
                <input
                  type="file"
                  className="form-control mb-3"
                  accept=".jpg,.jpeg,.png,.pdf"
                  onChange={(e) => setFinanceUploadFile(e.target.files[0])}
                />
                <label className="form-label fw-bold">Notes</label>
                <textarea
                  className="form-control"
                  rows="4"
                  placeholder="Enter notes..."
                  value={financeUploadNote}
                  onChange={(e) => setFinanceUploadNote(e.target.value)}
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowFinanceUploadModal(false)}>
                  Cancel
                </button>
                <button className="btn btn-primary" onClick={submitFinanceUpload} disabled={postLoading}>
                  {postLoading ? 'Uploading...' : 'Upload'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* FINANCE TEAM -> UPLOAD PROOF MODAL */}
      {showFinanceUploadModal && (
        <div className="modal d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Payment To Be Made</h5>
                <button type="button" className="btn-close" onClick={() => setShowFinanceUploadModal(false)} />
              </div>
              <div className="modal-body">
                <label className="form-label fw-bold">Upload Payment Document np</label>
                <input
                  type="file"
                  className="form-control mb-3"
                  accept=".jpg,.jpeg,.png,.pdf"
                  onChange={(e) => setFinanceUploadFile(e.target.files[0])}
                />
                <label className="form-label fw-bold">Notes</label>
                <textarea
                  className="form-control"
                  rows="4"
                  placeholder="Enter notes..."
                  value={financeUploadNote}
                  onChange={(e) => setFinanceUploadNote(e.target.value)}
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowFinanceUploadModal(false)}>
                  Cancel
                </button>
                <button className="btn btn-primary" onClick={submitFinanceUpload} disabled={postLoading}>
                  {postLoading ? 'Submitting...' : 'Submit'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* VIEW PAYMENT PROOF / BILL MODAL */}
      {showPaymentProofModal && (
        <div className="modal d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)', zIndex: 9999 }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header" style={{ background: '#198754', color: '#fff' }}>
                <h5 className="modal-title">💳 Payment Bill / Proof</h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => {
                    setShowPaymentProofModal(false);
                    setPaymentProofData(null);
                  }}
                />
              </div>

              <div className="modal-body">
                {paymentProofLoading ? (
                  <div className="text-center py-4">
                    <div className="spinner-border text-success" />
                    <p className="mt-2">Loading...</p>
                  </div>
                ) : paymentProofData ? (
                  <>
                    <div className="alert alert-secondary py-2 mb-3">
                      <strong>{paymentProofData.agreement_no}</strong>
                    </div>

                    <div className="mb-3">
                      <label className="text-muted d-block" style={{ fontSize: '12px' }}>
                        Uploaded By
                      </label>
                      <div className="fw-bold">{paymentProofData.uploaded_by_name || '-'}</div>
                    </div>

                    {paymentProofData.uploaded_at && (
                      <div className="mb-3">
                        <label className="text-muted d-block" style={{ fontSize: '12px' }}>
                          Uploaded At
                        </label>
                        <div>
                          {new Date(paymentProofData.uploaded_at).toLocaleString('en-IN', {
                            day: '2-digit',
                            month: 'short',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit',
                          })}
                        </div>
                      </div>
                    )}

                    {paymentProofData.notes && (
                      <div className="mb-3">
                        <label className="text-muted d-block" style={{ fontSize: '12px' }}>
                          Notes
                        </label>
                        <div className="border rounded p-2" style={{ background: '#f8f9fa', fontSize: '13px' }}>
                          {paymentProofData.notes}
                        </div>
                      </div>
                    )}

                    <div className="d-flex gap-2 mt-3">
                      <a
                        href={`${config.API_BASE_URL}${paymentProofData.proof_file}`}
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-sm"
                        style={{
                          padding: '6px 14px',
                          fontSize: '12px',
                          fontWeight: 600,
                          backgroundColor: '#0d6efd',
                          color: '#fff',
                          borderRadius: '6px',
                          textDecoration: 'none',
                        }}
                      >
                        👁 View Document
                      </a>

                      <a
                        href={`${config.API_BASE_URL}${paymentProofData.proof_file}`}
                        download
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-sm"
                        style={{
                          padding: '6px 14px',
                          fontSize: '12px',
                          fontWeight: 600,
                          backgroundColor: '#198754',
                          color: '#fff',
                          borderRadius: '6px',
                          textDecoration: 'none',
                        }}
                      >
                        ⬇ Download Document
                      </a>
                    </div>
                  </>
                ) : (
                  <div className="text-center text-muted py-4">No data found</div>
                )}
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowPaymentProofModal(false);
                    setPaymentProofData(null);
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ===== VISITOR LIST MODAL ===== */}
      {showVisitorListModal && (
        <div className="modal d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)', zIndex: 9999 }}>
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content" style={{ width: '120%' }}>
              <div className="modal-header" style={{ background: '#0d6efd', color: '#fff' }}>
                <h5 className="modal-title">👥 Vehicle Visitors — {visitorListAgreementNo}</h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => {
                    setShowVisitorListModal(false);
                    setVisitors([]);
                  }}
                />
              </div>

              <div className="modal-body">
                <div className="d-flex justify-content-end mb-3">
                  <button className="btn btn-sm btn-success" onClick={handleOpenAddVisitor}>
                    + Add Visitor
                  </button>
                </div>

                {visitorLoading ? (
                  <div className="text-center py-4">Loading visitors...</div>
                ) : visitors.length === 0 ? (
                  <div className="text-center text-muted py-4">No visitors added yet</div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-bordered align-middle">
                      <thead className="table-light">
                        <tr>
                          <th>#</th>
                          <th>Name</th>
                          <th>Number</th>
                          <th>Visiting Inspector</th>
                          <th>Type</th>
                          <th>Aadhaar</th>
                          <th>PAN</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {visitors.map((v, idx) => (
                          <tr key={v.id}>
                            <td>{idx + 1}</td>

                            <td>{v.name}</td>

                            <td>{v.number}</td>

                            <td>{v.visiting_inspector || '-'}</td>

                            <td>
                              <span
                                className="badge"
                                style={{
                                  backgroundColor:
                                    v.visitor_type === 'hot'
                                      ? '#dc3545'
                                      : v.visitor_type === 'warm'
                                      ? '#fd7e14'
                                      : '#0dcaf0',
                                  textTransform: 'capitalize',
                                }}
                              >
                                {v.visitor_type}
                              </span>
                            </td>

                            {/* Aadhaar */}
                            <td>
                              {v.aadhar_photo ? (
                                <a
                                  href={`${config.API_BASE_URL}${v.aadhar_photo}`}
                                  target="_blank"
                                  rel="noreferrer"
                                  style={{
                                    color: '#0d6efd',
                                    textDecoration: 'underline',
                                    fontWeight: 500,
                                    cursor: 'pointer',
                                  }}
                                >
                                  Aadhaar
                                </a>
                              ) : (
                                '-'
                              )}
                            </td>

                            {/* PAN */}
                            <td>
                              {v.pan_photo ? (
                                <a
                                  href={`${config.API_BASE_URL}${v.pan_photo}`}
                                  target="_blank"
                                  rel="noreferrer"
                                  style={{
                                    color: '#0d6efd',
                                    textDecoration: 'underline',
                                    fontWeight: 500,
                                    cursor: 'pointer',
                                  }}
                                >
                                  PAN
                                </a>
                              ) : (
                                '-'
                              )}
                            </td>

                            {/* Followup */}
                            <td>
                              <button className="btn btn-sm btn-success" onClick={() => openFollowupModal(v)}>
                                <i className="bi bi-telephone-fill" />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowVisitorListModal(false);
                    setVisitors([]);
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ===== ADD VISITOR MODAL ===== */}
      {showAddVisitorModal && (
        <div className="modal d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)', zIndex: 99999 }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Visitor</h5>
                <button type="button" className="btn-close" onClick={() => setShowAddVisitorModal(false)} />
              </div>

              <div className="modal-body">
                <label className="form-label fw-bold">Name</label>
                <input
                  type="text"
                  className="form-control mb-3"
                  placeholder="Enter visitor name"
                  value={visitorName}
                  onChange={(e) => setVisitorName(e.target.value)}
                />

                <label className="form-label fw-bold">Number</label>
                <input
                  type="text"
                  className="form-control mb-3"
                  placeholder="Enter mobile number"
                  value={visitorNumber}
                  onChange={(e) => setVisitorNumber(e.target.value)}
                />

                <label className="form-label fw-bold">Aadhar Photo</label>
                <input
                  type="file"
                  accept=".jpg,.jpeg,.png,.pdf"
                  className="form-control mb-3"
                  onChange={(e) => setVisitorAadharPhoto(e.target.files[0])}
                />

                <label className="form-label fw-bold">PAN Photo</label>
                <input
                  type="file"
                  accept=".jpg,.jpeg,.png,.pdf"
                  className="form-control mb-3"
                  onChange={(e) => setVisitorPanPhoto(e.target.files[0])}
                />

                <label className="form-label fw-bold">Visiting Inspector</label>
                <input
                  type="text"
                  className="form-control mb-3"
                  placeholder="Enter inspector name"
                  value={visitingInspector}
                  onChange={(e) => setVisitingInspector(e.target.value)}
                />

                <label className="form-label fw-bold">Visitor Type</label>
                <select className="form-select" value={visitorType} onChange={(e) => setVisitorType(e.target.value)}>
                  <option value="">Select Type</option>
                  <option value="hot">Hot</option>
                  <option value="warm">Warm</option>
                  <option value="cold">Cold</option>
                </select>
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowAddVisitorModal(false)}>
                  Cancel
                </button>
                <button className="btn btn-success" onClick={submitAddVisitor}>
                  Save Visitor
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showFollowupModal && (
        <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,.5)', zIndex: 99999 }}>
          <div className="modal-dialog modal-xl modal-dialog-scrollable">
            <div className="modal-content" style={{ width: '100%' }}>
              <div className="modal-header bg-primary text-white">
                <h5 className="modal-title">Vehicle Follow Up - {selectedVisitor?.name}</h5>

                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => {
                    setShowFollowupModal(false);
                    setFollowupList([]);
                    setFollowupType('');
                    setFollowupAction('');
                    setFollowupNote('');
                  }}
                />
              </div>

              <div className="modal-body">
                {/* ================= HISTORY ================= */}

                <h5 className="mb-3">Previous Followup History</h5>

                {followupList.length === 0 ? (
                  <div className="alert alert-light border text-center">No Followup History Found</div>
                ) : (
                  followupList.map((item, index) => (
                    <div key={index} className="card shadow-sm mb-3">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-2">
                            <label className="fw-bold">Date</label>

                            <div>
                              {item.date
                                ? `${new Date(item.date).toLocaleDateString('en-GB').replace(/\//g, '-')} ${new Date(
                                    item.date
                                  ).toLocaleTimeString('en-GB', {
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    second: '2-digit',
                                    hour12: false,
                                  })}`
                                : '-'}
                            </div>
                          </div>

                          <div className="col-md-2">
                            <label className="fw-bold">Type</label>

                            <div>{Number(item.followup_type) === 1 ? 'Interested' : 'Not Interested'}</div>
                          </div>

                          <div className="col-md-3">
                            <label className="fw-bold">Action</label>

                            <div>{item.followup_action}</div>
                          </div>

                          <div className="col-md-2">
                            <label className="fw-bold">User</label>

                            <div>{item.created_by_name || 'NA'}</div>
                          </div>

                          <div className="col-md-3">
                            <label className="fw-bold">Note</label>

                            <div>{item.note || '-'}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                )}

                <hr />

                {/* ================= NEW FOLLOWUP ================= */}

                <h5 className="mb-3">New Follow Up</h5>

                <div className="row">
                  <div className="col-md-4 mb-3">
                    <label className="fw-bold mb-1">Followup Type</label>

                    <select
                      className="form-select"
                      value={followupType}
                      onChange={(e) => {
                        setFollowupType(e.target.value);
                        setFollowupAction('');
                      }}
                    >
                      <option value="">Select Type</option>

                      <option value="1">Interested</option>

                      <option value="0">Not Interested</option>
                    </select>
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="fw-bold mb-1">Action</label>

                    <select
                      className="form-select"
                      value={followupAction}
                      onChange={(e) => setFollowupAction(e.target.value)}
                    >
                      <option value="">Select Action</option>

                      {followupMaster
                        .filter((item) => Number(item.followup_type) === Number(followupType))
                        .map((item) => (
                          <option key={item.id} value={item.action_name}>
                            {item.action_name}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="fw-bold mb-1">Note</label>

                    <textarea
                      className="form-control"
                      rows="2"
                      value={followupNote}
                      onChange={(e) => setFollowupNote(e.target.value)}
                      placeholder="Enter note"
                    />
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowFollowupModal(false);
                    setFollowupList([]);
                    setFollowupType('');
                    setFollowupAction('');
                    setFollowupNote('');
                  }}
                >
                  Close
                </button>

                <button className="btn btn-success" onClick={saveVehicleVisitorFollowup}>
                  Save Follow Up
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

    {showSimpleListingAmountModal && (
  <div
    className="modal d-block"
    tabIndex="-1"
    style={{
      background: 'rgba(15,23,42,0.55)',
      backdropFilter: 'blur(3px)',
      zIndex: 9999,
    }}
  >
    <div className="modal-dialog modal-dialog-centered modal-sm">
      <div
        className="modal-content"
        style={{
          width: '340px',
          border: 'none',
          borderRadius: '16px',
          overflow: 'hidden',
          boxShadow: '0 20px 50px rgba(0,0,0,0.25)',
          animation: 'listingAmountPop 0.2s ease-out',
        }}
      >
        {/* HEADER */}
        <div
          style={{
            background: 'linear-gradient(135deg, #16a34a, #0f9d58)',
            color: '#fff',
            padding: '18px 20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div
              style={{
                width: '34px',
                height: '34px',
                borderRadius: '50%',
                background: 'rgba(255,255,255,0.18)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '17px',
              }}
            >
              💰
            </div>
            <div>
              <div style={{ fontSize: '14px', fontWeight: 700, lineHeight: 1.2 }}>
                Approved Listing Amount
              </div>
              <div style={{ fontSize: '11px', opacity: 0.85 }}>Confirmed by Checker</div>
            </div>
          </div>

          <button
            type="button"
            onClick={() => {
              setShowSimpleListingAmountModal(false);
              setSimpleListingAmount(null);
            }}
            style={{
              border: 'none',
              background: 'rgba(255,255,255,0.18)',
              color: '#fff',
              width: '26px',
              height: '26px',
              borderRadius: '50%',
              fontSize: '14px',
              lineHeight: 1,
              cursor: 'pointer',
            }}
          >
            ✕
          </button>
        </div>

        {/* BODY */}
        <div style={{ padding: '26px 22px', background: '#fff' }}>
          <div
            style={{
              background: '#f0fdf4',
              border: '1.5px solid #bbf7d0',
              borderRadius: '12px',
              padding: '18px',
              textAlign: 'center',
            }}
          >
            <div
              style={{
                fontSize: '11px',
                fontWeight: 600,
                color: '#15803d',
                letterSpacing: '0.5px',
                textTransform: 'uppercase',
                marginBottom: '6px',
              }}
            >
              Final Amount
            </div>
            <div style={{ fontSize: '30px', fontWeight: 800, color: '#15803d' }}>
              ₹ {Number(simpleListingAmount || 0).toLocaleString('en-IN')}
            </div>
          </div>
        </div>

        {/* FOOTER */}
        <div
          style={{
            padding: '14px 22px 20px',
            background: '#fff',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <button
            onClick={() => {
              setShowSimpleListingAmountModal(false);
              setSimpleListingAmount(null);
            }}
            style={{
              border: 'none',
              background: '#16a34a',
              color: '#fff',
              padding: '9px 28px',
              borderRadius: '8px',
              fontWeight: 600,
              fontSize: '13px',
              cursor: 'pointer',
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>

    <style>{`
      @keyframes listingAmountPop {
        0%   { opacity: 0; transform: translateY(-8px) scale(0.97); }
        100% { opacity: 1; transform: translateY(0) scale(1); }
      }
    `}</style>
  </div>
)}
    </Container>
  );
}

export default EligibleRepoList;
